// // import React, { useEffect, useState, useCallback, useRef } from 'react';
// // import {
// //   Box,
// //   Typography,
// //   FormControl,
// //   InputLabel,
// //   Select,
// //   MenuItem,
// //   Tooltip,
// //   IconButton,
// //   Chip,
// //   TextField,
// // } from '@mui/material';
// // import {
// //   AccountBalance as BankIcon,
// //   Gavel as GavelIcon,
// //   Description as DocsIcon,
// //   Payments as PaymentIcon,
// //   FilterList as FilterIcon,
// //   Refresh as RefreshIcon,
// //   TrendingUp as TrendingUpIcon,
// //   TrendingDown as TrendingDownIcon,
// //   Assessment as AssessmentIcon,
// //   CheckCircle as CheckIcon,
// //   Cancel as CancelIcon,
// //   Timeline as TimelineIcon,
// //   AccountBalanceWallet as WalletIcon,
// //   HourglassEmpty as PendingIcon,
// // } from '@mui/icons-material';
// // import {
// //   AreaChart,
// //   Area,
// //   BarChart,
// //   Bar,
// //   XAxis,
// //   YAxis,
// //   CartesianGrid,
// //   Tooltip as ReTooltip,
// //   ResponsiveContainer,
// //   PieChart,
// //   Pie,
// //   Cell,
// // } from 'recharts';
// // import api from '../../../api/axiosInterceptor';
// // import { SnackBarComponent } from '../../../Components/snackBar/snackBar';

// // // ─────────────────────────────────────────────
// // // DESIGN TOKENS — LIGHT THEME
// // // ─────────────────────────────────────────────
// // const T = {
// //   pageBg:    '#F0F4F8',
// //   cardBg:    '#FFFFFF',
// //   cardBgAlt: '#F7FAFC',
// //   border:    '#E2E8F0',
// //   borderHov: '#CBD5E0',
// //   shadow:    '0 1px 4px rgba(0,0,0,0.06),0 4px 16px rgba(0,0,0,0.06)',
// //   shadowHov: '0 8px 32px rgba(0,0,0,0.12),0 2px 8px rgba(0,0,0,0.06)',
// //   shadowHero:'0 4px 20px rgba(0,0,0,0.10)',

// //   blue:      '#3182CE', blueSoft: '#EBF8FF', blueMid: '#BEE3F8',
// //   teal:      '#2C7A7B', tealSoft: '#E6FFFA', tealMid: '#81E6D9',
// //   green:     '#276749', greenSoft:'#F0FFF4', greenMid:'#9AE6B4',
// //   red:       '#C53030', redSoft:  '#FFF5F5', redMid:  '#FEB2B2',
// //   amber:     '#C05621', amberSoft:'#FFFAF0', amberMid:'#FBD38D',
// //   purple:    '#553C9A', purpleSoft:'#FAF5FF',purpleMid:'#D6BCFA',
// //   gray:      '#4A5568', graySoft: '#EDF2F7', grayMid: '#CBD5E0',

// //   gradBlue:   'linear-gradient(135deg,#2B6CB0 0%,#3182CE 100%)',
// //   gradGreen:  'linear-gradient(135deg,#276749 0%,#38A169 100%)',
// //   gradRed:    'linear-gradient(135deg,#9B2C2C 0%,#C53030 100%)',
// //   gradAmber:  'linear-gradient(135deg,#9C4221 0%,#DD6B20 100%)',
// //   gradTeal:   'linear-gradient(135deg,#285E61 0%,#319795 100%)',
// //   gradPurple: 'linear-gradient(135deg,#44337A 0%,#6B46C1 100%)',

// //   textPrimary:   '#1A202C',
// //   textSecondary: '#4A5568',
// //   textMuted:     '#718096',
// //   textLight:     '#A0AEC0',
// // };

// // // ─────────────────────────────────────────────
// // // FORMAT CURRENCY (INR)
// // // ─────────────────────────────────────────────
// // const fmt = (n) => {
// //   n = Number(n) || 0;
// //   if (n >= 1_00_00_000) return `₹${(n / 1_00_00_000).toFixed(2)} Cr`;
// //   if (n >= 1_00_000)    return `₹${(n / 1_00_000).toFixed(2)} L`;
// //   return `₹${n.toLocaleString('en-IN')}`;
// // };

// // // ─────────────────────────────────────────────
// // // ANIMATED NUMBER
// // // ─────────────────────────────────────────────
// // const AnimatedNumber = ({ value, format, duration = 1200 }) => {
// //   const [display, setDisplay] = useState(0);
// //   const rafRef  = useRef();
// //   const prevVal = useRef(0);

// //   useEffect(() => {
// //     const from  = prevVal.current;
// //     const to    = Number(value) || 0;
// //     prevVal.current = to;
// //     const start = Date.now();
// //     const tick  = () => {
// //       const p    = Math.min((Date.now() - start) / duration, 1);
// //       const ease = 1 - Math.pow(1 - p, 4);
// //       setDisplay(from + (to - from) * ease);
// //       if (p < 1) rafRef.current = requestAnimationFrame(tick);
// //     };
// //     cancelAnimationFrame(rafRef.current);
// //     rafRef.current = requestAnimationFrame(tick);
// //     return () => cancelAnimationFrame(rafRef.current);
// //   }, [value]);

// //   return (
// //     <span>
// //       {format
// //         ? format(Math.round(display))
// //         : Math.round(display).toLocaleString('en-IN')}
// //     </span>
// //   );
// // };

// // // ─────────────────────────────────────────────
// // // BASE CARD
// // // ─────────────────────────────────────────────
// // const Card = ({ children, sx = {}, delay = 0 }) => {
// //   const [hovered, setHovered] = useState(false);
// //   const [visible, setVisible] = useState(false);

// //   useEffect(() => {
// //     const t = setTimeout(() => setVisible(true), delay);
// //     return () => clearTimeout(t);
// //   }, [delay]);

// //   return (
// //     <Box
// //       onMouseEnter={() => setHovered(true)}
// //       onMouseLeave={() => setHovered(false)}
// //       sx={{
// //         background:   T.cardBg,
// //         borderRadius: '14px',
// //         border:       `1.5px solid ${hovered ? T.borderHov : T.border}`,
// //         boxShadow:    hovered ? T.shadowHov : T.shadow,
// //         transition:   'all 0.3s cubic-bezier(0.23,1,0.32,1)',
// //         transform:    visible
// //           ? hovered ? 'translateY(-3px)' : 'translateY(0)'
// //           : 'translateY(16px)',
// //         opacity:  visible ? 1 : 0,
// //         overflow: 'hidden',
// //         ...sx,
// //       }}
// //     >
// //       {children}
// //     </Box>
// //   );
// // };

// // // ─────────────────────────────────────────────
// // // HERO METRIC CARD
// // // ─────────────────────────────────────────────
// // const HeroCard = ({ label, value, icon: Icon, gradient, format, delay }) => {
// //   const [hovered, setHovered] = useState(false);
// //   const [visible, setVisible] = useState(false);

// //   useEffect(() => {
// //     const t = setTimeout(() => setVisible(true), delay);
// //     return () => clearTimeout(t);
// //   }, [delay]);

// //   return (
// //     <Box
// //       onMouseEnter={() => setHovered(true)}
// //       onMouseLeave={() => setHovered(false)}
// //       sx={{
// //         background:   gradient,
// //         borderRadius: '14px',
// //         p:            2.5,
// //         position:     'relative',
// //         overflow:     'hidden',
// //         boxShadow:    hovered ? '0 12px 40px rgba(0,0,0,0.2)' : T.shadowHero,
// //         transition:   'all 0.35s cubic-bezier(0.23,1,0.32,1)',
// //         transform:    visible
// //           ? hovered ? 'translateY(-4px) scale(1.02)' : 'translateY(0) scale(1)'
// //           : 'translateY(20px) scale(0.97)',
// //         opacity: visible ? 1 : 0,
// //       }}
// //     >
// //       <Box sx={{
// //         position: 'absolute', right: -20, top: -20,
// //         width: 100, height: 100, borderRadius: '50%',
// //         background: 'rgba(255,255,255,0.08)',
// //         transition: 'transform 0.4s',
// //         transform: hovered ? 'scale(1.2)' : 'scale(1)',
// //       }} />
// //       <Box sx={{
// //         position: 'absolute', right: 16, top: 16,
// //         width: 44, height: 44, borderRadius: '50%',
// //         background: 'rgba(255,255,255,0.15)',
// //         display: 'flex', alignItems: 'center', justifyContent: 'center',
// //       }}>
// //         <Icon sx={{ color: '#fff', fontSize: 20 }} />
// //       </Box>
// //       <Typography sx={{
// //         fontSize: 10, color: 'rgba(255,255,255,0.75)',
// //         textTransform: 'uppercase', letterSpacing: 1.2, mb: 1,
// //       }}>
// //         {label}
// //       </Typography>
// //       <Typography sx={{ fontSize: 24, fontWeight: 800, color: '#fff', lineHeight: 1 }}>
// //         <AnimatedNumber value={value} format={format} />
// //       </Typography>
// //       <Box sx={{
// //         position: 'absolute', bottom: 0, left: 0, right: 0, height: 3,
// //         background: 'rgba(255,255,255,0.2)',
// //       }} />
// //     </Box>
// //   );
// // };

// // // ─────────────────────────────────────────────
// // // SECTION HEADER
// // // ─────────────────────────────────────────────
// // const SectionHeader = ({ icon: Icon, title, color, colorBg }) => (
// //   <Box display="flex" alignItems="center" gap={1.5} mb={2.5}>
// //     <Box sx={{
// //       width: 34, height: 34, borderRadius: '10px',
// //       background: colorBg || `${color}18`,
// //       border: `1.5px solid ${color}35`,
// //       display: 'flex', alignItems: 'center', justifyContent: 'center',
// //       flexShrink: 0,
// //     }}>
// //       <Icon sx={{ color, fontSize: 17 }} />
// //     </Box>
// //     <Typography sx={{
// //       fontSize: 12, fontWeight: 700, color: T.textPrimary,
// //       textTransform: 'uppercase', letterSpacing: 1.5,
// //     }}>
// //       {title}
// //     </Typography>
// //     <Box sx={{
// //       flex: 1, height: '1.5px',
// //       background: `linear-gradient(90deg,${color}40,transparent)`,
// //     }} />
// //   </Box>
// // );

// // // ─────────────────────────────────────────────
// // // DUAL STAT ROW
// // // ─────────────────────────────────────────────
// // const DualStatRow = ({ label, yes, no, colorYes = T.green, colorNo = T.red, delay }) => {
// //   const total   = (yes + no) || 1;
// //   const pct     = Math.round((yes / total) * 100);
// //   const [visible, setVisible] = useState(false);

// //   useEffect(() => {
// //     const t = setTimeout(() => setVisible(true), delay + 200);
// //     return () => clearTimeout(t);
// //   }, [delay]);

// //   return (
// //     <Box sx={{
// //       p: 1.5, borderRadius: '10px',
// //       background: T.cardBgAlt,
// //       border: `1.5px solid ${T.border}`,
// //       transition: 'border-color 0.2s',
// //       '&:hover': { borderColor: `${colorYes}55` },
// //     }}>
// //       <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
// //         <Typography sx={{ fontSize: 11, color: T.textSecondary, fontWeight: 500 }}>
// //           {label}
// //         </Typography>
// //         <Box display="flex" gap={0.75}>
// //           <Chip
// //             icon={<CheckIcon sx={{ fontSize: '11px !important', color: `${colorYes} !important` }} />}
// //             label={yes}
// //             size="small"
// //             sx={{
// //               height: 20, fontSize: 11, fontWeight: 700,
// //               bgcolor: `${colorYes}15`, color: colorYes,
// //               border: `1px solid ${colorYes}35`,
// //               '& .MuiChip-label': { px: 0.75 },
// //             }}
// //           />
// //           <Chip
// //             icon={<CancelIcon sx={{ fontSize: '11px !important', color: `${colorNo} !important` }} />}
// //             label={no}
// //             size="small"
// //             sx={{
// //               height: 20, fontSize: 11, fontWeight: 700,
// //               bgcolor: `${colorNo}12`, color: colorNo,
// //               border: `1px solid ${colorNo}30`,
// //               '& .MuiChip-label': { px: 0.75 },
// //             }}
// //           />
// //         </Box>
// //       </Box>
// //       <Box sx={{ height: 5, borderRadius: 3, background: `${colorNo}20`, overflow: 'hidden' }}>
// //         <Box sx={{
// //           height: '100%',
// //           width: visible ? `${pct}%` : '0%',
// //           background: `linear-gradient(90deg,${colorYes},${colorYes}bb)`,
// //           borderRadius: 3,
// //           transition: 'width 1.3s cubic-bezier(0.23,1,0.32,1)',
// //           boxShadow: `2px 0 8px ${colorYes}44`,
// //         }} />
// //       </Box>
// //     </Box>
// //   );
// // };

// // // ─────────────────────────────────────────────
// // // STAT MINI — 3-column variant for payment
// // // ─────────────────────────────────────────────
// // const StatMini = ({ label, value, total, color, softColor, delay }) => {
// //   const pct     = total > 0 ? Math.round((value / total) * 100) : 0;
// //   const [visible, setVisible] = useState(false);

// //   useEffect(() => {
// //     const t = setTimeout(() => setVisible(true), delay + 200);
// //     return () => clearTimeout(t);
// //   }, [delay]);

// //   return (
// //     <Box sx={{
// //       p: 2, borderRadius: '12px',
// //       background: softColor,
// //       border: `1.5px solid ${color}30`,
// //     }}>
// //       <Typography sx={{
// //         fontSize: 10, color, textTransform: 'uppercase',
// //         letterSpacing: 1, fontWeight: 700, mb: 0.5,
// //       }}>
// //         {label}
// //       </Typography>
// //       <Typography sx={{ fontSize: 24, fontWeight: 800, color: T.textPrimary, lineHeight: 1 }}>
// //         <AnimatedNumber value={value} />
// //       </Typography>
// //       <Box sx={{ mt: 1.25, height: 4, borderRadius: 2, background: `${color}20` }}>
// //         <Box sx={{
// //           height: '100%',
// //           width: visible ? `${pct}%` : '0%',
// //           background: color,
// //           borderRadius: 2,
// //           transition: 'width 1.3s cubic-bezier(0.23,1,0.32,1)',
// //         }} />
// //       </Box>
// //       <Typography sx={{ fontSize: 10, color, fontWeight: 600, mt: 0.5 }}>
// //         {pct}% of total
// //       </Typography>
// //     </Box>
// //   );
// // };

// // // ─────────────────────────────────────────────
// // // AMOUNT BAR
// // // ─────────────────────────────────────────────
// // const AmountBar = ({ label, value, maxVal, color, softColor, delay }) => {
// //   const pct     = maxVal > 0 ? Math.min(100, Math.round((value / maxVal) * 100)) : 0;
// //   const [visible, setVisible] = useState(false);

// //   useEffect(() => {
// //     const t = setTimeout(() => setVisible(true), delay + 200);
// //     return () => clearTimeout(t);
// //   }, [delay]);

// //   return (
// //     <Box mb={1.75}>
// //       <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.6}>
// //         <Box display="flex" alignItems="center" gap={0.75}>
// //           <Box sx={{ width: 8, height: 8, borderRadius: '50%', background: color, flexShrink: 0 }} />
// //           <Typography sx={{ fontSize: 12, color: T.textSecondary }}>{label}</Typography>
// //         </Box>
// //         <Typography sx={{ fontSize: 12, color, fontWeight: 700 }}>{fmt(value)}</Typography>
// //       </Box>
// //       <Box sx={{ height: 6, borderRadius: 3, background: softColor || `${color}20`, overflow: 'hidden' }}>
// //         <Box sx={{
// //           height: '100%',
// //           width: visible ? `${pct}%` : '0%',
// //           background: `linear-gradient(90deg,${color}cc,${color})`,
// //           borderRadius: 3,
// //           transition: 'width 1.4s cubic-bezier(0.23,1,0.32,1)',
// //         }} />
// //       </Box>
// //     </Box>
// //   );
// // };

// // // ─────────────────────────────────────────────
// // // CUSTOM RECHARTS TOOLTIP
// // // ─────────────────────────────────────────────
// // const CustomTooltip = ({ active, payload, label }) => {
// //   if (!active || !payload?.length) return null;
// //   const amountKeys = new Set(['Deposited', 'Returned', 'Excess', 'Agreed Amt', 'Recovered']);
// //   return (
// //     <Box sx={{
// //       background: '#fff',
// //       border: `1.5px solid ${T.border}`,
// //       borderRadius: '10px',
// //       p: 1.5,
// //       boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
// //       minWidth: 160,
// //     }}>
// //       <Typography sx={{ fontSize: 11, color: T.textMuted, mb: 0.75 }}>{label}</Typography>
// //       {payload.map((p, i) => (
// //         <Typography key={i} sx={{ fontSize: 12, color: p.color, fontWeight: 700 }}>
// //           {p.name}: {amountKeys.has(p.name) ? fmt(p.value) : p.value}
// //         </Typography>
// //       ))}
// //     </Box>
// //   );
// // };

// // // ─────────────────────────────────────────────
// // // TOGGLE CHIP
// // // ─────────────────────────────────────────────
// // const ToggleChip = ({ label, active, onClick }) => (
// //   <Chip
// //     label={label}
// //     size="small"
// //     onClick={onClick}
// //     sx={{
// //       height: 24, fontSize: 11, fontWeight: 600, cursor: 'pointer',
// //       bgcolor: active ? T.blue : 'transparent',
// //       color:   active ? '#fff' : T.textMuted,
// //       border:  `1.5px solid ${active ? T.blue : T.border}`,
// //       transition: 'all 0.2s',
// //       '&:hover': { bgcolor: active ? T.blue : T.pageBg },
// //     }}
// //   />
// // );

// // // ─────────────────────────────────────────────
// // // CHART LEGEND DOT
// // // ─────────────────────────────────────────────
// // const LegendDot = ({ color, label }) => (
// //   <Box display="flex" alignItems="center" gap={0.75}>
// //     <Box sx={{ width: 10, height: 10, borderRadius: 1, background: color }} />
// //     <Typography sx={{ fontSize: 11, color: T.textMuted }}>{label}</Typography>
// //   </Box>
// // );

// // // ─────────────────────────────────────────────
// // // MAIN DASHBOARD
// // // ─────────────────────────────────────────────
// // export const CaDashboardComponent = () => {
// //   const [data,          setData]          = useState(null);
// //   const [loading,       setLoading]       = useState(false);
// //   const [feList,        setFeList]        = useState([]);
// //   const [selectedFe,    setSelectedFe]    = useState('');
// //   const [shrName,       setShrName]       = useState('');
// //   const [startDate,     setStartDate]     = useState('');
// //   const [endDate,       setEndDate]       = useState('');
// //   const [chartMode,     setChartMode]     = useState('daily');
// //   const [snackbarOpen,  setSnackbarOpen]  = useState(false);
// //   const [snackbarMsg,   setSnackbarMsg]   = useState('');
// //   const [snackbarSev,   setSnackbarSev]   = useState('info');
// //   const [lastRefreshed, setLastRefreshed] = useState(null);
// //   const [spinning,      setSpinning]      = useState(false);
// //   const [mounted,       setMounted]       = useState(false);

// //   useEffect(() => { setTimeout(() => setMounted(true), 80); }, []);

// //   useEffect(() => {
// //     api.get('/fe-mgmt/fe-base/')
// //       .then((r) => setFeList(r.data || []))
// //       .catch(() => setFeList([]));
// //   }, []);

// //   const fetchDashboard = useCallback(() => {
// //     if (!selectedFe) return;
// //     setLoading(true);
// //     setSpinning(true);
// //     const params = new URLSearchParams();
// //     params.append('fe', selectedFe);
// //     if (shrName)   params.append('shr_name', shrName);
// //     if (startDate) params.append('start_date', startDate);
// //     if (endDate)   params.append('end_date', endDate);

// //     api.get(`/excess_payment_mgmt/ca-epms-dashboard/?${params.toString()}`)
// //       .then((r) => {
// //         setData(r.data);
// //         setLastRefreshed(new Date());
// //         setSnackbarMsg('Dashboard refreshed successfully');
// //         setSnackbarSev('success');
// //         setSnackbarOpen(true);
// //       })
// //       .catch(() => {
// //         setSnackbarMsg('Failed to load dashboard data');
// //         setSnackbarSev('error');
// //         setSnackbarOpen(true);
// //       })
// //       .finally(() => {
// //         setLoading(false);
// //         setTimeout(() => setSpinning(false), 500);
// //       });
// //   }, [selectedFe, shrName, startDate, endDate]);

// //   useEffect(() => {
// //     if (!selectedFe) { setData(null); return; }
// //     fetchDashboard();
// //   }, [selectedFe, fetchDashboard]);

// //   // ── Derived values
// //   const s      = data?.summary || {};
// //   const charts = data?.charts  || {};
// //   const rawChartData = charts[chartMode] || [];

// //   const chartData = rawChartData.map((row) => ({
// //     label:     (row.day || row.month || '').split('T')[0],
// //     Records:   row.count      || 0,
// //     Deposited: row.deposited  || 0,
// //     Returned:  row.returned   || 0,
// //     Excess:    row.excess     || 0,
// //   }));

// //   const paymentChartData = rawChartData.map((row) => ({
// //     label:        (row.day || row.month || '').split('T')[0],
// //     'Agreed Amt': row.agreed_amount      || 0,
// //     'Recovered':  row.recovered_amount   || 0,
// //     'Agreed #':   row.agreed_to_pay_count || 0,
// //   }));

// //   // ── 3-category pie
// //   const paymentPie = [
// //     { name: 'Agreed',     value: s.agreed_to_pay     || 0, color: T.green  },
// //     { name: 'Not Agreed', value: s.not_agreed_to_pay || 0, color: T.red    },
// //     { name: 'Pending',    value: s.pending_payment   || 0, color: T.amber  },
// //   ];

// //   const recoveryRate = s.total_agreed_amount > 0
// //     ? Math.min(100, Math.round((s.total_recovered_amount / s.total_agreed_amount) * 100))
// //     : 0;

// //   // ──────────────────────────────────────────────────────────────
// //   return (
// //     <Box sx={{ minHeight: '100vh', background: T.pageBg, p: { xs: 2, md: 3 } }}>

// //       {/* ── PAGE HEADER ── */}
// //       <Box sx={{
// //         display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
// //         mb: 3,
// //         opacity:   mounted ? 1 : 0,
// //         transform: mounted ? 'none' : 'translateY(-10px)',
// //         transition: 'all 0.5s ease',
// //       }}>
// //         <Box>
// //           <Box display="flex" alignItems="center" gap={1.5}>
// //             <Box sx={{
// //               width: 10, height: 10, borderRadius: '50%',
// //               background: loading ? T.amber : T.green,
// //               boxShadow: loading ? `0 0 0 3px ${T.amberMid}` : `0 0 0 3px ${T.greenMid}`,
// //               transition: 'all 0.3s',
// //               animation: loading ? 'none' : 'hpulse 2.5s ease-in-out infinite',
// //               '@keyframes hpulse': {
// //                 '0%,100%': { boxShadow: `0 0 0 3px ${T.greenMid}` },
// //                 '50%':     { boxShadow: `0 0 0 6px ${T.greenMid}55` },
// //               },
// //             }} />
// //             <Typography sx={{
// //               fontSize: { xs: 17, md: 21 },
// //               fontWeight: 800, color: T.textPrimary, letterSpacing: -0.5,
// //             }}>
// //               SPLOCA — EPMS Dashboard
// //             </Typography>
// //             <Chip label="Live" size="small" sx={{
// //               height: 20, fontSize: 10, fontWeight: 700,
// //               bgcolor: T.greenSoft, color: T.green,
// //               border: `1px solid ${T.greenMid}`,
// //             }} />
// //           </Box>
// //           <Typography sx={{ fontSize: 12, color: T.textMuted, mt: 0.5 }}>
// //             Excess Payment Management Intelligence
// //             {lastRefreshed && ` · Refreshed at ${lastRefreshed.toLocaleTimeString()}`}
// //           </Typography>
// //         </Box>

// //         <Tooltip title="Refresh Dashboard">
// //           <span>
// //             <IconButton
// //               onClick={fetchDashboard}
// //               disabled={loading || !selectedFe}
// //               size="small"
// //               sx={{
// //                 color: T.blue, background: T.blueSoft,
// //                 border: `1.5px solid ${T.blueMid}`,
// //                 borderRadius: '10px', width: 36, height: 36,
// //                 '&:hover': { background: T.blueMid, transform: 'scale(1.05)' },
// //                 '& svg': {
// //                   transition: 'transform 0.6s linear',
// //                   transform: spinning ? 'rotate(360deg)' : 'rotate(0deg)',
// //                 },
// //               }}
// //             >
// //               <RefreshIcon fontSize="small" />
// //             </IconButton>
// //           </span>
// //         </Tooltip>
// //       </Box>

// //       {/* ── FILTER BAR ── */}
// //       <Card delay={80} sx={{ p: 2, mb: 3 }}>
// //         <Box display="flex" gap={2} alignItems="flex-end" flexWrap="wrap">
// //           <Box display="flex" alignItems="center" gap={1} alignSelf="center">
// //             <FilterIcon sx={{ color: T.textLight, fontSize: 16 }} />
// //             <Typography sx={{
// //               fontSize: 11, color: T.textLight,
// //               textTransform: 'uppercase', letterSpacing: 1, fontWeight: 600,
// //             }}>
// //               Filters
// //             </Typography>
// //           </Box>

// //           <FormControl size="small" sx={{ minWidth: 220 }}>
// //             <InputLabel sx={{ fontSize: 12 }}>Select FE *</InputLabel>
// //             <Select
// //               value={selectedFe}
// //               label="Select FE *"
// //               onChange={(e) => setSelectedFe(e.target.value)}
// //               sx={{ fontSize: 12, borderRadius: '10px' }}
// //               displayEmpty
// //             >
// //               <MenuItem value="" disabled>
// //                 <em style={{ color: T.textLight }}>— Please Select FE —</em>
// //               </MenuItem>
// //               {feList.map((fe) => (
// //                 <MenuItem key={fe.id} value={fe.id} sx={{ fontSize: 12 }}>
// //                   {fe.name || fe.name_of_fe || fe.id}
// //                 </MenuItem>
// //               ))}
// //             </Select>
// //           </FormControl>

// //           <TextField
// //             size="small" label="SHR Name" placeholder="Search SHR..."
// //             value={shrName} onChange={(e) => setShrName(e.target.value)}
// //             disabled={!selectedFe}
// //             sx={{ minWidth: 180, '& .MuiOutlinedInput-root': { borderRadius: '10px', fontSize: 12 }, '& label': { fontSize: 12 } }}
// //           />
// //           <TextField
// //             size="small" label="From Date" type="date"
// //             value={startDate} onChange={(e) => setStartDate(e.target.value)}
// //             InputLabelProps={{ shrink: true }} disabled={!selectedFe}
// //             sx={{ minWidth: 160, '& .MuiOutlinedInput-root': { borderRadius: '10px', fontSize: 12 }, '& label': { fontSize: 12 } }}
// //           />
// //           <TextField
// //             size="small" label="To Date" type="date"
// //             value={endDate} onChange={(e) => setEndDate(e.target.value)}
// //             InputLabelProps={{ shrink: true }} disabled={!selectedFe}
// //             sx={{ minWidth: 160, '& .MuiOutlinedInput-root': { borderRadius: '10px', fontSize: 12 }, '& label': { fontSize: 12 } }}
// //           />
// //         </Box>
// //       </Card>

// //       {/* ── EMPTY STATE ── */}
// //       {!selectedFe && (
// //         <Box sx={{
// //           display: 'flex', flexDirection: 'column',
// //           alignItems: 'center', justifyContent: 'center',
// //           py: 12, gap: 2,
// //           opacity: mounted ? 1 : 0,
// //           transform: mounted ? 'none' : 'translateY(12px)',
// //           transition: 'all 0.5s ease',
// //         }}>
// //           <Box sx={{
// //             width: 80, height: 80, borderRadius: '24px',
// //             background: T.blueSoft, border: `2px dashed ${T.blueMid}`,
// //             display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 1,
// //           }}>
// //             <AssessmentIcon sx={{ fontSize: 36, color: T.blue, opacity: 0.6 }} />
// //           </Box>
// //           <Typography sx={{ fontSize: 18, fontWeight: 700, color: T.textPrimary }}>
// //             Select a Field Executive
// //           </Typography>
// //           <Typography sx={{ fontSize: 13, color: T.textMuted, textAlign: 'center', maxWidth: 340 }}>
// //             Please choose an FE from the filter above to load the EPMS dashboard data.
// //           </Typography>
// //           <Box sx={{
// //             mt: 1, display: 'flex', alignItems: 'center', gap: 1,
// //             px: 2, py: 1, borderRadius: '10px',
// //             background: T.blueSoft, border: `1.5px solid ${T.blueMid}`,
// //           }}>
// //             <Typography sx={{ fontSize: 12, color: T.blue, fontWeight: 600 }}>
// //               ↑ Use the "Select FE" dropdown above
// //             </Typography>
// //           </Box>
// //         </Box>
// //       )}

// //       {/* ══ DASHBOARD CONTENT ══ */}
// //       {selectedFe && (
// //         <>
// //           {/* ── HERO METRICS ── */}
// //           <Box sx={{
// //             display: 'grid',
// //             gridTemplateColumns: { xs: '1fr 1fr', sm: 'repeat(3,1fr)', md: 'repeat(6,1fr)' },
// //             gap: 2, mb: 3,
// //           }}>
// //             <HeroCard label="Total Records"    value={s.total_records||0}          icon={AssessmentIcon}   gradient={T.gradBlue}   delay={100} />
// //             <HeroCard label="Total Deposited"  value={s.total_deposited||0}         icon={BankIcon}         gradient={T.gradGreen}  format={fmt} delay={150} />
// //             <HeroCard label="Total Returned"   value={s.total_returned||0}          icon={TrendingDownIcon} gradient={T.gradAmber}  format={fmt} delay={200} />
// //             <HeroCard label="Excess Amount"    value={s.total_excess||0}            icon={TrendingUpIcon}   gradient={T.gradRed}    format={fmt} delay={250} />
// //             <HeroCard label="Agreed Amount"    value={s.total_agreed_amount||0}     icon={WalletIcon}       gradient={T.gradTeal}   format={fmt} delay={300} />
// //             <HeroCard label="Amount Recovered" value={s.total_recovered_amount||0}  icon={CheckIcon}        gradient={T.gradPurple} format={fmt} delay={350} />
// //           </Box>

// //           {/* ── CHARTS ROW ── */}
// //           <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '2fr 1fr' }, gap: 2, mb: 3 }}>

// //             {/* Area chart */}
// //             <Card delay={400} sx={{ p: 3 }}>
// //               <Box display="flex" justifyContent="space-between" alignItems="center" mb={2.5}>
// //                 <Box display="flex" alignItems="center" gap={1}>
// //                   <TimelineIcon sx={{ color: T.blue, fontSize: 18 }} />
// //                   <Typography sx={{ fontSize: 13, fontWeight: 700, color: T.textPrimary }}>
// //                     Amount &amp; Records Trend
// //                   </Typography>
// //                 </Box>
// //                 <Box display="flex" gap={1}>
// //                   <ToggleChip label="Daily"   active={chartMode === 'daily'}   onClick={() => setChartMode('daily')} />
// //                   <ToggleChip label="Monthly" active={chartMode === 'monthly'} onClick={() => setChartMode('monthly')} />
// //                 </Box>
// //               </Box>
// //               <Box display="flex" gap={2} mb={1.5} flexWrap="wrap">
// //                 <LegendDot color={T.blue}  label="Records" />
// //                 <LegendDot color={T.teal}  label="Deposited" />
// //                 <LegendDot color={T.amber} label="Returned" />
// //                 <LegendDot color={T.red}   label="Excess" />
// //               </Box>
// //               <ResponsiveContainer width="100%" height={220}>
// //                 <AreaChart data={chartData} margin={{ top: 5, right: 5, bottom: 5, left: 0 }}>
// //                   <defs>
// //                     <linearGradient id="gRec" x1="0" y1="0" x2="0" y2="1">
// //                       <stop offset="5%"  stopColor={T.blue}  stopOpacity={0.18} />
// //                       <stop offset="95%" stopColor={T.blue}  stopOpacity={0.01} />
// //                     </linearGradient>
// //                     <linearGradient id="gDep" x1="0" y1="0" x2="0" y2="1">
// //                       <stop offset="5%"  stopColor={T.teal}  stopOpacity={0.18} />
// //                       <stop offset="95%" stopColor={T.teal}  stopOpacity={0.01} />
// //                     </linearGradient>
// //                     <linearGradient id="gRet" x1="0" y1="0" x2="0" y2="1">
// //                       <stop offset="5%"  stopColor={T.amber} stopOpacity={0.18} />
// //                       <stop offset="95%" stopColor={T.amber} stopOpacity={0.01} />
// //                     </linearGradient>
// //                     <linearGradient id="gExc" x1="0" y1="0" x2="0" y2="1">
// //                       <stop offset="5%"  stopColor={T.red}   stopOpacity={0.18} />
// //                       <stop offset="95%" stopColor={T.red}   stopOpacity={0.01} />
// //                     </linearGradient>
// //                   </defs>
// //                   <CartesianGrid strokeDasharray="3 3" stroke={T.border} vertical={false} />
// //                   <XAxis dataKey="label" tick={{ fill: T.textMuted, fontSize: 10 }} axisLine={false} tickLine={false} tickFormatter={(v) => String(v)?.slice(5) || v} />
// //                   <YAxis yAxisId="left"  tick={{ fill: T.textMuted, fontSize: 10 }} axisLine={false} tickLine={false} />
// //                   <YAxis yAxisId="right" tick={{ fill: T.textMuted, fontSize: 10 }} axisLine={false} tickLine={false} orientation="right" tickFormatter={(v) => fmt(v)} />
// //                   <ReTooltip content={<CustomTooltip />} />
// //                   <Area yAxisId="left"  type="monotone" dataKey="Records"   name="Records"   stroke={T.blue}  fill="url(#gRec)" strokeWidth={2} dot={false} activeDot={{ r: 4, fill: T.blue }} />
// //                   <Area yAxisId="right" type="monotone" dataKey="Deposited" name="Deposited" stroke={T.teal}  fill="url(#gDep)" strokeWidth={2} dot={false} activeDot={{ r: 4, fill: T.teal }} />
// //                   <Area yAxisId="right" type="monotone" dataKey="Returned"  name="Returned"  stroke={T.amber} fill="url(#gRet)" strokeWidth={2} dot={false} activeDot={{ r: 4, fill: T.amber }} />
// //                   <Area yAxisId="right" type="monotone" dataKey="Excess"    name="Excess"    stroke={T.red}   fill="url(#gExc)" strokeWidth={2} dot={false} activeDot={{ r: 4, fill: T.red }} />
// //                 </AreaChart>
// //               </ResponsiveContainer>
// //             </Card>

// //             {/* Pie + Recovery — now 3-slice */}
// //             <Card delay={450} sx={{ p: 3 }}>
// //               <Box display="flex" alignItems="center" gap={1} mb={2}>
// //                 <PaymentIcon sx={{ color: T.amber, fontSize: 18 }} />
// //                 <Typography sx={{ fontSize: 13, fontWeight: 700, color: T.textPrimary }}>
// //                   Payment Agreement
// //                 </Typography>
// //               </Box>

// //               <Box display="flex" flexDirection="column" alignItems="center">
// //                 <ResponsiveContainer width="100%" height={150}>
// //                   <PieChart>
// //                     <Pie
// //                       data={paymentPie} cx="50%" cy="50%"
// //                       innerRadius={42} outerRadius={65}
// //                       paddingAngle={4} dataKey="value"
// //                       startAngle={90} endAngle={-270}
// //                     >
// //                       {paymentPie.map((entry, i) => (
// //                         <Cell key={i} fill={entry.color} stroke={`${entry.color}30`} strokeWidth={2} />
// //                       ))}
// //                     </Pie>
// //                     <ReTooltip contentStyle={{
// //                       background: '#fff', border: `1px solid ${T.border}`,
// //                       borderRadius: 8, fontSize: 12, boxShadow: T.shadow,
// //                     }} />
// //                   </PieChart>
// //                 </ResponsiveContainer>

// //                 {/* 3-item legend */}
// //                 <Box display="flex" gap={2} mt={0.5} flexWrap="wrap" justifyContent="center">
// //                   {paymentPie.map((d) => (
// //                     <Box key={d.name} display="flex" alignItems="center" gap={0.75}>
// //                       <Box sx={{ width: 8, height: 8, borderRadius: '50%', background: d.color }} />
// //                       <Typography sx={{ fontSize: 11, color: T.textSecondary }}>
// //                         {d.name} ({d.value})
// //                       </Typography>
// //                     </Box>
// //                   ))}
// //                 </Box>
// //               </Box>

// //               {/* Recovery rate */}
// //               <Box sx={{
// //                 mt: 2, p: 1.5, borderRadius: '10px',
// //                 background: T.greenSoft, border: `1.5px solid ${T.greenMid}`,
// //               }}>
// //                 <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.75}>
// //                   <Typography sx={{ fontSize: 11, color: T.textSecondary, fontWeight: 600 }}>
// //                     Recovery Rate
// //                   </Typography>
// //                   <Typography sx={{ fontSize: 14, color: T.green, fontWeight: 800 }}>
// //                     {recoveryRate}%
// //                   </Typography>
// //                 </Box>
// //                 <Box sx={{ height: 6, borderRadius: 3, background: `${T.greenMid}55` }}>
// //                   <Box sx={{
// //                     height: '100%', width: `${recoveryRate}%`,
// //                     background: `linear-gradient(90deg,${T.green},#38A169)`,
// //                     borderRadius: 3,
// //                     transition: 'width 1.4s cubic-bezier(0.23,1,0.32,1)',
// //                   }} />
// //                 </Box>
// //                 <Typography sx={{ fontSize: 10, color: T.textMuted, mt: 0.5 }}>
// //                   {fmt(s.total_recovered_amount || 0)} of {fmt(s.total_agreed_amount || 0)}
// //                 </Typography>
// //               </Box>
// //             </Card>
// //           </Box>

// //           {/* ── PAYMENT TREND CHART ── */}
// //           <Card delay={480} sx={{ p: 3, mb: 3 }}>
// //             <Box display="flex" justifyContent="space-between" alignItems="center" mb={2.5}>
// //               <Box display="flex" alignItems="center" gap={1}>
// //                 <WalletIcon sx={{ color: T.purple, fontSize: 18 }} />
// //                 <Typography sx={{ fontSize: 13, fontWeight: 700, color: T.textPrimary }}>
// //                   Agreed Amount vs Recovered — {chartMode === 'daily' ? 'Daily' : 'Monthly'}
// //                 </Typography>
// //               </Box>
// //               <Box display="flex" gap={2}>
// //                 <LegendDot color={T.teal}   label="Agreed Amt" />
// //                 <LegendDot color={T.green}  label="Recovered" />
// //                 <LegendDot color={T.purple} label="Agreed #" />
// //               </Box>
// //             </Box>
// //             <ResponsiveContainer width="100%" height={200}>
// //               <BarChart data={paymentChartData} margin={{ top: 5, right: 10, bottom: 5, left: 0 }} barSize={chartMode === 'daily' ? 8 : 22} barGap={3}>
// //                 <defs>
// //                   <linearGradient id="barAgreed" x1="0" y1="0" x2="0" y2="1">
// //                     <stop offset="0%"   stopColor={T.teal}    stopOpacity={0.9} />
// //                     <stop offset="100%" stopColor={T.tealMid} stopOpacity={0.5} />
// //                   </linearGradient>
// //                   <linearGradient id="barRec" x1="0" y1="0" x2="0" y2="1">
// //                     <stop offset="0%"   stopColor={T.green}   stopOpacity={0.9} />
// //                     <stop offset="100%" stopColor={T.greenMid} stopOpacity={0.5} />
// //                   </linearGradient>
// //                   <linearGradient id="barAgrCount" x1="0" y1="0" x2="0" y2="1">
// //                     <stop offset="0%"   stopColor={T.purple}   stopOpacity={0.9} />
// //                     <stop offset="100%" stopColor={T.purpleMid} stopOpacity={0.5} />
// //                   </linearGradient>
// //                 </defs>
// //                 <CartesianGrid strokeDasharray="3 3" stroke={T.border} vertical={false} />
// //                 <XAxis dataKey="label" tick={{ fill: T.textMuted, fontSize: 10 }} axisLine={false} tickLine={false} tickFormatter={(v) => String(v)?.slice(5) || v} />
// //                 <YAxis yAxisId="amt"   tick={{ fill: T.textMuted, fontSize: 10 }} axisLine={false} tickLine={false} tickFormatter={(v) => fmt(v)} />
// //                 <YAxis yAxisId="count" tick={{ fill: T.textMuted, fontSize: 10 }} axisLine={false} tickLine={false} orientation="right" />
// //                 <ReTooltip content={<CustomTooltip />} />
// //                 <Bar yAxisId="amt"   dataKey="Agreed Amt" name="Agreed Amt" fill="url(#barAgreed)"   radius={[4,4,0,0]} />
// //                 <Bar yAxisId="amt"   dataKey="Recovered"  name="Recovered"  fill="url(#barRec)"      radius={[4,4,0,0]} />
// //                 <Bar yAxisId="count" dataKey="Agreed #"   name="Agreed #"   fill="url(#barAgrCount)" radius={[4,4,0,0]} />
// //               </BarChart>
// //             </ResponsiveContainer>
// //           </Card>

// //           {/* ── ORDER STATUS ── */}
// //           <Card delay={500} sx={{ p: 3, mb: 3 }}>
// //             <SectionHeader icon={GavelIcon} title="Order Status Overview" color={T.blue} colorBg={T.blueSoft} />
// //             <Box sx={{
// //               display: 'grid',
// //               gridTemplateColumns: { xs: '1fr', sm: 'repeat(2,1fr)', md: 'repeat(4,1fr)' },
// //               gap: 1.5,
// //             }}>
// //               <DualStatRow label="Freezing Order Issued"       yes={s.freezing_issued||0}            no={s.freezing_not_issued||0}            colorYes={T.blue}  colorNo={T.red}       delay={520} />
// //               <DualStatRow label="Summons Issued"              yes={s.summons_issued||0}             no={s.summons_not_issued||0}             colorYes={T.amber} colorNo={T.textMuted} delay={560} />
// //               <DualStatRow label="Bank Freezed"                yes={s.bank_freezed||0}               no={s.bank_not_freezed||0}               colorYes={T.red}   colorNo={T.textMuted} delay={600} />
// //               <DualStatRow label="Partial Unfreeze Submitted"  yes={s.partial_unfreeze_submitted||0} no={s.partial_unfreeze_not_submitted||0} colorYes={T.teal}  colorNo={T.textMuted} delay={640} />
// //               <DualStatRow label="Partial Unfreezed"           yes={s.partial_unfreezed||0}          no={s.partial_not_unfreezed||0}          colorYes={T.green} colorNo={T.textMuted} delay={680} />
// //               <DualStatRow label="Defreezing Submitted"        yes={s.defreezing_submitted||0}       no={s.defreezing_not_submitted||0}       colorYes={T.amber} colorNo={T.textMuted} delay={720} />
// //               <DualStatRow label="Bank De-freezed"             yes={s.bank_defreezed||0}             no={s.bank_not_defreezed||0}             colorYes={T.green} colorNo={T.textMuted} delay={760} />
// //             </Box>
// //           </Card>

// //           {/* ── DOCS + PAYMENT ── */}
// //           <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2, mb: 3 }}>

// //             {/* Document Status */}
// //             <Card delay={800} sx={{ p: 3 }}>
// //               <SectionHeader icon={DocsIcon} title="Document Status" color={T.teal} colorBg={T.tealSoft} />
// //               <Box display="flex" flexDirection="column" gap={1.5}>
// //                 <DualStatRow label="Affidavit Submitted"      yes={s.affidavit_submitted||0}      no={s.affidavit_not_submitted||0}      colorYes={T.teal}  colorNo={T.red} delay={820} />
// //                 <DualStatRow label="Bank Statement Submitted" yes={s.bank_statement_submitted||0} no={s.bank_statement_not_submitted||0} colorYes={T.blue}  colorNo={T.red} delay={860} />
// //                 <DualStatRow label="PAN Card Submitted"       yes={s.pan_submitted||0}            no={s.pan_not_submitted||0}            colorYes={T.amber} colorNo={T.red} delay={900} />
// //               </Box>
// //             </Card>

// //             {/* Payment Breakdown — 3 StatMini cards */}
// //             <Card delay={820} sx={{ p: 3 }}>
// //               <SectionHeader icon={PaymentIcon} title="Payment Breakdown" color={T.amber} colorBg={T.amberSoft} />

// //               {/* 3-column grid: Agreed / Not Agreed / Pending */}
// //               <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 1.5, mb: 2 }}>
// //                 <StatMini
// //                   label="Agreed"
// //                   value={s.agreed_to_pay || 0}
// //                   total={s.total_records || 1}
// //                   color={T.green}
// //                   softColor={T.greenSoft}
// //                   delay={840}
// //                 />
// //                 <StatMini
// //                   label="Not Agreed"
// //                   value={s.not_agreed_to_pay || 0}
// //                   total={s.total_records || 1}
// //                   color={T.red}
// //                   softColor={T.redSoft}
// //                   delay={880}
// //                 />
// //                 <StatMini
// //                   label="Pending"
// //                   value={s.pending_payment || 0}
// //                   total={s.total_records || 1}
// //                   color={T.amber}
// //                   softColor={T.amberSoft}
// //                   delay={920}
// //                 />
// //               </Box>

// //               {/* Amount Flow */}
// //               <Box sx={{
// //                 p: 2, borderRadius: '10px',
// //                 background: T.cardBgAlt, border: `1.5px solid ${T.border}`,
// //               }}>
// //                 <Typography sx={{
// //                   fontSize: 11, color: T.textMuted, textTransform: 'uppercase',
// //                   letterSpacing: 1, fontWeight: 600, mb: 1.5,
// //                 }}>
// //                   Amount Flow
// //                 </Typography>
// //                 {[
// //                   { label: 'Total Excess',   value: s.total_excess||0,           color: T.red,   softColor: `${T.redMid}40`   },
// //                   { label: 'Agreed Amount',  value: s.total_agreed_amount||0,    color: T.amber, softColor: `${T.amberMid}40` },
// //                   { label: 'Recovered',      value: s.total_recovered_amount||0, color: T.green, softColor: `${T.greenMid}40` },
// //                 ].map((item, i) => (
// //                   <AmountBar key={i} {...item} maxVal={s.total_excess || 1} delay={900 + i * 60} />
// //                 ))}
// //               </Box>
// //             </Card>
// //           </Box>

// //           {/* ── BAR CHART — Record Count ── */}
// //           <Card delay={1000} sx={{ p: 3 }}>
// //             <Box display="flex" justifyContent="space-between" alignItems="center" mb={2.5}>
// //               <Box display="flex" alignItems="center" gap={1}>
// //                 <AssessmentIcon sx={{ color: T.blue, fontSize: 18 }} />
// //                 <Typography sx={{ fontSize: 13, fontWeight: 700, color: T.textPrimary }}>
// //                   Record Count — {chartMode === 'daily' ? 'Daily' : 'Monthly'} Bar View
// //                 </Typography>
// //               </Box>
// //               <Box display="flex" alignItems="center" gap={0.75}>
// //                 <Box sx={{ width: 10, height: 10, borderRadius: 1, background: T.blue }} />
// //                 <Typography sx={{ fontSize: 11, color: T.textMuted }}>Records per period</Typography>
// //               </Box>
// //             </Box>
// //             <ResponsiveContainer width="100%" height={180}>
// //               <BarChart data={chartData} margin={{ top: 5, right: 10, bottom: 5, left: 0 }} barSize={chartMode === 'daily' ? 10 : 28}>
// //                 <defs>
// //                   <linearGradient id="barGrad" x1="0" y1="0" x2="0" y2="1">
// //                     <stop offset="0%"   stopColor={T.blue}    stopOpacity={0.9} />
// //                     <stop offset="100%" stopColor={T.blueMid} stopOpacity={0.5} />
// //                   </linearGradient>
// //                 </defs>
// //                 <CartesianGrid strokeDasharray="3 3" stroke={T.border} vertical={false} />
// //                 <XAxis dataKey="label" tick={{ fill: T.textMuted, fontSize: 10 }} axisLine={false} tickLine={false} tickFormatter={(v) => String(v)?.slice(5) || v} />
// //                 <YAxis tick={{ fill: T.textMuted, fontSize: 10 }} axisLine={false} tickLine={false} />
// //                 <ReTooltip content={<CustomTooltip />} />
// //                 <Bar dataKey="Records" fill="url(#barGrad)" radius={[5, 5, 0, 0]} />
// //               </BarChart>
// //             </ResponsiveContainer>
// //           </Card>
// //         </>
// //       )}

// //       <SnackBarComponent
// //         open={snackbarOpen}
// //         message={snackbarMsg}
// //         severity={snackbarSev}
// //         onClose={() => setSnackbarOpen(false)}
// //       />
// //     </Box>
// //   );
// // };

// // export default CaDashboardComponent;


// import React, { useEffect, useState, useCallback, useRef } from 'react';
// import {
//   Box,
//   Typography,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Tooltip,
//   IconButton,
//   Chip,
//   TextField,
//   CircularProgress,
// } from '@mui/material';
// import {
//   AccountBalance as BankIcon,
//   Gavel as GavelIcon,
//   Description as DocsIcon,
//   Payments as PaymentIcon,
//   FilterList as FilterIcon,
//   Refresh as RefreshIcon,
//   TrendingUp as TrendingUpIcon,
//   TrendingDown as TrendingDownIcon,
//   Assessment as AssessmentIcon,
//   CheckCircle as CheckIcon,
//   Cancel as CancelIcon,
//   Timeline as TimelineIcon,
//   AccountBalanceWallet as WalletIcon,
//   HourglassEmpty as PendingIcon,
//   FileDownload as DownloadIcon,
// } from '@mui/icons-material';
// import {
//   AreaChart,
//   Area,
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip as ReTooltip,
//   ResponsiveContainer,
//   PieChart,
//   Pie,
//   Cell,
// } from 'recharts';
// import api from '../../../api/axiosInterceptor';
// import { SnackBarComponent } from '../../../Components/snackBar/snackBar';

// // ─────────────────────────────────────────────
// // DESIGN TOKENS — LIGHT THEME
// // ─────────────────────────────────────────────
// const T = {
//   pageBg:    '#F0F4F8',
//   cardBg:    '#FFFFFF',
//   cardBgAlt: '#F7FAFC',
//   border:    '#E2E8F0',
//   borderHov: '#CBD5E0',
//   shadow:    '0 1px 4px rgba(0,0,0,0.06),0 4px 16px rgba(0,0,0,0.06)',
//   shadowHov: '0 8px 32px rgba(0,0,0,0.12),0 2px 8px rgba(0,0,0,0.06)',
//   shadowHero:'0 4px 20px rgba(0,0,0,0.10)',

//   blue:      '#3182CE', blueSoft: '#EBF8FF', blueMid: '#BEE3F8',
//   teal:      '#2C7A7B', tealSoft: '#E6FFFA', tealMid: '#81E6D9',
//   green:     '#276749', greenSoft:'#F0FFF4', greenMid:'#9AE6B4',
//   red:       '#C53030', redSoft:  '#FFF5F5', redMid:  '#FEB2B2',
//   amber:     '#C05621', amberSoft:'#FFFAF0', amberMid:'#FBD38D',
//   purple:    '#553C9A', purpleSoft:'#FAF5FF',purpleMid:'#D6BCFA',
//   gray:      '#4A5568', graySoft: '#EDF2F7', grayMid: '#CBD5E0',

//   gradBlue:   'linear-gradient(135deg,#2B6CB0 0%,#3182CE 100%)',
//   gradGreen:  'linear-gradient(135deg,#276749 0%,#38A169 100%)',
//   gradRed:    'linear-gradient(135deg,#9B2C2C 0%,#C53030 100%)',
//   gradAmber:  'linear-gradient(135deg,#9C4221 0%,#DD6B20 100%)',
//   gradTeal:   'linear-gradient(135deg,#285E61 0%,#319795 100%)',
//   gradPurple: 'linear-gradient(135deg,#44337A 0%,#6B46C1 100%)',

//   textPrimary:   '#1A202C',
//   textSecondary: '#4A5568',
//   textMuted:     '#718096',
//   textLight:     '#A0AEC0',
// };

// // ─────────────────────────────────────────────
// // FORMAT CURRENCY (INR) — NO ROUNDING, exact paise
// // ─────────────────────────────────────────────
// const fmt = (n) => {
//   n = Number(n) || 0;
//   if (n >= 1_00_00_000) return `₹${(n / 1_00_00_000).toFixed(4)} Cr`;
//   if (n >= 1_00_000)    return `₹${(n / 1_00_000).toFixed(4)} L`;
//   return `₹${n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
// };

// // ─────────────────────────────────────────────
// // ANIMATED NUMBER — no Math.round, preserves decimals
// // ─────────────────────────────────────────────
// const AnimatedNumber = ({ value, format, duration = 1200 }) => {
//   const [display, setDisplay] = useState(0);
//   const rafRef  = useRef();
//   const prevVal = useRef(0);

//   useEffect(() => {
//     const from  = prevVal.current;
//     const to    = Number(value) || 0;
//     prevVal.current = to;
//     const start = Date.now();
//     const tick  = () => {
//       const p    = Math.min((Date.now() - start) / duration, 1);
//       const ease = 1 - Math.pow(1 - p, 4);
//       setDisplay(from + (to - from) * ease);
//       if (p < 1) rafRef.current = requestAnimationFrame(tick);
//     };
//     cancelAnimationFrame(rafRef.current);
//     rafRef.current = requestAnimationFrame(tick);
//     return () => cancelAnimationFrame(rafRef.current);
//   }, [value]);

//   if (format) {
//     return <span>{format(display)}</span>;
//   }
//   return (
//     <span>
//       {display === (Number(value) || 0)
//         ? (Number(value) || 0).toLocaleString('en-IN')
//         : Math.floor(display).toLocaleString('en-IN')}
//     </span>
//   );
// };

// // ─────────────────────────────────────────────
// // BASE CARD
// // ─────────────────────────────────────────────
// const Card = ({ children, sx = {}, delay = 0 }) => {
//   const [hovered, setHovered] = useState(false);
//   const [visible, setVisible] = useState(false);

//   useEffect(() => {
//     const t = setTimeout(() => setVisible(true), delay);
//     return () => clearTimeout(t);
//   }, [delay]);

//   return (
//     <Box
//       onMouseEnter={() => setHovered(true)}
//       onMouseLeave={() => setHovered(false)}
//       sx={{
//         background:   T.cardBg,
//         borderRadius: '14px',
//         border:       `1.5px solid ${hovered ? T.borderHov : T.border}`,
//         boxShadow:    hovered ? T.shadowHov : T.shadow,
//         transition:   'all 0.3s cubic-bezier(0.23,1,0.32,1)',
//         transform:    visible
//           ? hovered ? 'translateY(-3px)' : 'translateY(0)'
//           : 'translateY(16px)',
//         opacity:  visible ? 1 : 0,
//         overflow: 'hidden',
//         ...sx,
//       }}
//     >
//       {children}
//     </Box>
//   );
// };

// // ─────────────────────────────────────────────
// // HERO METRIC CARD
// // ─────────────────────────────────────────────
// const HeroCard = ({ label, value, icon: Icon, gradient, format, delay }) => {
//   const [hovered, setHovered] = useState(false);
//   const [visible, setVisible] = useState(false);

//   useEffect(() => {
//     const t = setTimeout(() => setVisible(true), delay);
//     return () => clearTimeout(t);
//   }, [delay]);

//   return (
//     <Box
//       onMouseEnter={() => setHovered(true)}
//       onMouseLeave={() => setHovered(false)}
//       sx={{
//         background:   gradient,
//         borderRadius: '14px',
//         p:            2.5,
//         position:     'relative',
//         overflow:     'hidden',
//         boxShadow:    hovered ? '0 12px 40px rgba(0,0,0,0.2)' : T.shadowHero,
//         transition:   'all 0.35s cubic-bezier(0.23,1,0.32,1)',
//         transform:    visible
//           ? hovered ? 'translateY(-4px) scale(1.02)' : 'translateY(0) scale(1)'
//           : 'translateY(20px) scale(0.97)',
//         opacity: visible ? 1 : 0,
//       }}
//     >
//       <Box sx={{
//         position: 'absolute', right: -20, top: -20,
//         width: 100, height: 100, borderRadius: '50%',
//         background: 'rgba(255,255,255,0.08)',
//         transition: 'transform 0.4s',
//         transform: hovered ? 'scale(1.2)' : 'scale(1)',
//       }} />
//       <Box sx={{
//         position: 'absolute', right: 16, top: 16,
//         width: 44, height: 44, borderRadius: '50%',
//         background: 'rgba(255,255,255,0.15)',
//         display: 'flex', alignItems: 'center', justifyContent: 'center',
//       }}>
//         <Icon sx={{ color: '#fff', fontSize: 20 }} />
//       </Box>
//       <Typography sx={{
//         fontSize: 10, color: 'rgba(255,255,255,0.75)',
//         textTransform: 'uppercase', letterSpacing: 1.2, mb: 1,
//       }}>
//         {label}
//       </Typography>
//       <Typography sx={{ fontSize: 24, fontWeight: 800, color: '#fff', lineHeight: 1 }}>
//         <AnimatedNumber value={value} format={format} />
//       </Typography>
//       <Box sx={{
//         position: 'absolute', bottom: 0, left: 0, right: 0, height: 3,
//         background: 'rgba(255,255,255,0.2)',
//       }} />
//     </Box>
//   );
// };

// // ─────────────────────────────────────────────
// // SECTION HEADER
// // ─────────────────────────────────────────────
// const SectionHeader = ({ icon: Icon, title, color, colorBg }) => (
//   <Box display="flex" alignItems="center" gap={1.5} mb={2.5}>
//     <Box sx={{
//       width: 34, height: 34, borderRadius: '10px',
//       background: colorBg || `${color}18`,
//       border: `1.5px solid ${color}35`,
//       display: 'flex', alignItems: 'center', justifyContent: 'center',
//       flexShrink: 0,
//     }}>
//       <Icon sx={{ color, fontSize: 17 }} />
//     </Box>
//     <Typography sx={{
//       fontSize: 12, fontWeight: 700, color: T.textPrimary,
//       textTransform: 'uppercase', letterSpacing: 1.5,
//     }}>
//       {title}
//     </Typography>
//     <Box sx={{
//       flex: 1, height: '1.5px',
//       background: `linear-gradient(90deg,${color}40,transparent)`,
//     }} />
//   </Box>
// );

// // ─────────────────────────────────────────────
// // DUAL STAT ROW
// // ─────────────────────────────────────────────
// const DualStatRow = ({ label, yes, no, colorYes = T.green, colorNo = T.red, delay }) => {
//   const total   = (yes + no) || 1;
//   const pct     = Math.round((yes / total) * 100);
//   const [visible, setVisible] = useState(false);

//   useEffect(() => {
//     const t = setTimeout(() => setVisible(true), delay + 200);
//     return () => clearTimeout(t);
//   }, [delay]);

//   return (
//     <Box sx={{
//       p: 1.5, borderRadius: '10px',
//       background: T.cardBgAlt,
//       border: `1.5px solid ${T.border}`,
//       transition: 'border-color 0.2s',
//       '&:hover': { borderColor: `${colorYes}55` },
//     }}>
//       <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
//         <Typography sx={{ fontSize: 11, color: T.textSecondary, fontWeight: 500 }}>
//           {label}
//         </Typography>
//         <Box display="flex" gap={0.75}>
//           <Chip
//             icon={<CheckIcon sx={{ fontSize: '11px !important', color: `${colorYes} !important` }} />}
//             label={yes}
//             size="small"
//             sx={{
//               height: 20, fontSize: 11, fontWeight: 700,
//               bgcolor: `${colorYes}15`, color: colorYes,
//               border: `1px solid ${colorYes}35`,
//               '& .MuiChip-label': { px: 0.75 },
//             }}
//           />
//           <Chip
//             icon={<CancelIcon sx={{ fontSize: '11px !important', color: `${colorNo} !important` }} />}
//             label={no}
//             size="small"
//             sx={{
//               height: 20, fontSize: 11, fontWeight: 700,
//               bgcolor: `${colorNo}12`, color: colorNo,
//               border: `1px solid ${colorNo}30`,
//               '& .MuiChip-label': { px: 0.75 },
//             }}
//           />
//         </Box>
//       </Box>
//       <Box sx={{ height: 5, borderRadius: 3, background: `${colorNo}20`, overflow: 'hidden' }}>
//         <Box sx={{
//           height: '100%',
//           width: visible ? `${pct}%` : '0%',
//           background: `linear-gradient(90deg,${colorYes},${colorYes}bb)`,
//           borderRadius: 3,
//           transition: 'width 1.3s cubic-bezier(0.23,1,0.32,1)',
//           boxShadow: `2px 0 8px ${colorYes}44`,
//         }} />
//       </Box>
//     </Box>
//   );
// };

// // ─────────────────────────────────────────────
// // STAT MINI — 3-column variant for payment
// // ─────────────────────────────────────────────
// const StatMini = ({ label, value, total, color, softColor, delay }) => {
//   const pct     = total > 0 ? Math.round((value / total) * 100) : 0;
//   const [visible, setVisible] = useState(false);

//   useEffect(() => {
//     const t = setTimeout(() => setVisible(true), delay + 200);
//     return () => clearTimeout(t);
//   }, [delay]);

//   return (
//     <Box sx={{
//       p: 2, borderRadius: '12px',
//       background: softColor,
//       border: `1.5px solid ${color}30`,
//     }}>
//       <Typography sx={{
//         fontSize: 10, color, textTransform: 'uppercase',
//         letterSpacing: 1, fontWeight: 700, mb: 0.5,
//       }}>
//         {label}
//       </Typography>
//       <Typography sx={{ fontSize: 24, fontWeight: 800, color: T.textPrimary, lineHeight: 1 }}>
//         <AnimatedNumber value={value} />
//       </Typography>
//       <Box sx={{ mt: 1.25, height: 4, borderRadius: 2, background: `${color}20` }}>
//         <Box sx={{
//           height: '100%',
//           width: visible ? `${pct}%` : '0%',
//           background: color,
//           borderRadius: 2,
//           transition: 'width 1.3s cubic-bezier(0.23,1,0.32,1)',
//         }} />
//       </Box>
//       <Typography sx={{ fontSize: 10, color, fontWeight: 600, mt: 0.5 }}>
//         {pct}% of total
//       </Typography>
//     </Box>
//   );
// };

// // ─────────────────────────────────────────────
// // AMOUNT BAR — no rounding on displayed value
// // ─────────────────────────────────────────────
// const AmountBar = ({ label, value, maxVal, color, softColor, delay }) => {
//   const pct     = maxVal > 0 ? Math.min(100, Math.round((value / maxVal) * 100)) : 0;
//   const [visible, setVisible] = useState(false);

//   useEffect(() => {
//     const t = setTimeout(() => setVisible(true), delay + 200);
//     return () => clearTimeout(t);
//   }, [delay]);

//   return (
//     <Box mb={1.75}>
//       <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.6}>
//         <Box display="flex" alignItems="center" gap={0.75}>
//           <Box sx={{ width: 8, height: 8, borderRadius: '50%', background: color, flexShrink: 0 }} />
//           <Typography sx={{ fontSize: 12, color: T.textSecondary }}>{label}</Typography>
//         </Box>
//         <Typography sx={{ fontSize: 12, color, fontWeight: 700 }}>{fmt(value)}</Typography>
//       </Box>
//       <Box sx={{ height: 6, borderRadius: 3, background: softColor || `${color}20`, overflow: 'hidden' }}>
//         <Box sx={{
//           height: '100%',
//           width: visible ? `${pct}%` : '0%',
//           background: `linear-gradient(90deg,${color}cc,${color})`,
//           borderRadius: 3,
//           transition: 'width 1.4s cubic-bezier(0.23,1,0.32,1)',
//         }} />
//       </Box>
//     </Box>
//   );
// };

// // ─────────────────────────────────────────────
// // CUSTOM RECHARTS TOOLTIP
// // ─────────────────────────────────────────────
// const CustomTooltip = ({ active, payload, label }) => {
//   if (!active || !payload?.length) return null;
//   const amountKeys = new Set(['Deposited', 'Returned', 'Excess', 'Agreed Amt', 'Recovered']);
//   return (
//     <Box sx={{
//       background: '#fff',
//       border: `1.5px solid ${T.border}`,
//       borderRadius: '10px',
//       p: 1.5,
//       boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
//       minWidth: 160,
//     }}>
//       <Typography sx={{ fontSize: 11, color: T.textMuted, mb: 0.75 }}>{label}</Typography>
//       {payload.map((p, i) => (
//         <Typography key={i} sx={{ fontSize: 12, color: p.color, fontWeight: 700 }}>
//           {p.name}: {amountKeys.has(p.name) ? fmt(p.value) : p.value}
//         </Typography>
//       ))}
//     </Box>
//   );
// };

// // ─────────────────────────────────────────────
// // TOGGLE CHIP
// // ─────────────────────────────────────────────
// const ToggleChip = ({ label, active, onClick }) => (
//   <Chip
//     label={label}
//     size="small"
//     onClick={onClick}
//     sx={{
//       height: 24, fontSize: 11, fontWeight: 600, cursor: 'pointer',
//       bgcolor: active ? T.blue : 'transparent',
//       color:   active ? '#fff' : T.textMuted,
//       border:  `1.5px solid ${active ? T.blue : T.border}`,
//       transition: 'all 0.2s',
//       '&:hover': { bgcolor: active ? T.blue : T.pageBg },
//     }}
//   />
// );

// // ─────────────────────────────────────────────
// // CHART LEGEND DOT
// // ─────────────────────────────────────────────
// const LegendDot = ({ color, label }) => (
//   <Box display="flex" alignItems="center" gap={0.75}>
//     <Box sx={{ width: 10, height: 10, borderRadius: 1, background: color }} />
//     <Typography sx={{ fontSize: 11, color: T.textMuted }}>{label}</Typography>
//   </Box>
// );

// // ─────────────────────────────────────────────
// // MAIN DASHBOARD
// // ─────────────────────────────────────────────
// export const CaDashboardComponent = () => {
//   const [data,           setData]           = useState(null);
//   const [loading,        setLoading]        = useState(false);
//   const [exporting,      setExporting]      = useState(false);
//   const [feList,         setFeList]         = useState([]);
//   const [selectedFe,     setSelectedFe]     = useState('');
//   const [shrName,        setShrName]        = useState('');
//   const [startDate,      setStartDate]      = useState('');
//   const [endDate,        setEndDate]        = useState('');
//   const [chartMode,      setChartMode]      = useState('daily');
//   const [snackbarOpen,   setSnackbarOpen]   = useState(false);
//   const [snackbarMsg,    setSnackbarMsg]    = useState('');
//   const [snackbarSev,    setSnackbarSev]    = useState('info');
//   const [lastRefreshed,  setLastRefreshed]  = useState(null);
//   const [spinning,       setSpinning]       = useState(false);
//   const [mounted,        setMounted]        = useState(false);

//   useEffect(() => { setTimeout(() => setMounted(true), 80); }, []);

//   useEffect(() => {
//     api.get('/fe-mgmt/fe-base/')
//       .then((r) => setFeList(r.data || []))
//       .catch(() => setFeList([]));
//   }, []);

//   // ── Build shared query-params string
//   const buildParams = useCallback(() => {
//     const params = new URLSearchParams();
//     if (selectedFe) params.append('fe', selectedFe);
//     if (shrName)    params.append('shr_name', shrName);
//     if (startDate)  params.append('start_date', startDate);
//     if (endDate)    params.append('end_date', endDate);
//     return params.toString();
//   }, [selectedFe, shrName, startDate, endDate]);

//   const fetchDashboard = useCallback(() => {
//     if (!selectedFe) return;
//     setLoading(true);
//     setSpinning(true);

//     api.get(`/excess_payment_mgmt/ca-epms-dashboard/?${buildParams()}`)
//       .then((r) => {
//         setData(r.data);
//         setLastRefreshed(new Date());
//         setSnackbarMsg('Dashboard refreshed successfully');
//         setSnackbarSev('success');
//         setSnackbarOpen(true);
//       })
//       .catch(() => {
//         setSnackbarMsg('Failed to load dashboard data');
//         setSnackbarSev('error');
//         setSnackbarOpen(true);
//       })
//       .finally(() => {
//         setLoading(false);
//         setTimeout(() => setSpinning(false), 500);
//       });
//   }, [selectedFe, buildParams]);

//   useEffect(() => {
//     if (!selectedFe) { setData(null); return; }
//     fetchDashboard();
//   }, [selectedFe, fetchDashboard]);

//   // ── Excel Export
//   const handleExport = useCallback(() => {
//     if (!selectedFe || exporting) return;
//     setExporting(true);
//     setSnackbarMsg('Preparing Excel export…');
//     setSnackbarSev('info');
//     setSnackbarOpen(true);

//     api.get(
//       `/excess_payment_mgmt/sploca-epms-dashboard/export/?${buildParams()}`,
//       { responseType: 'blob' }
//     )
//       .then((response) => {
//         const disposition = response.headers?.['content-disposition'] || '';
//         const match = disposition.match(/filename="?([^"]+)"?/);
//         const filename = match
//           ? match[1]
//           : `CA_EPMS_${new Date().toISOString().slice(0, 10)}.xlsx`;

//         const url  = window.URL.createObjectURL(new Blob([response.data]));
//         const link = document.createElement('a');
//         link.href  = url;
//         link.setAttribute('download', filename);
//         document.body.appendChild(link);
//         link.click();
//         link.remove();
//         window.URL.revokeObjectURL(url);

//         setSnackbarMsg('Excel file downloaded successfully');
//         setSnackbarSev('success');
//         setSnackbarOpen(true);
//       })
//       .catch(() => {
//         setSnackbarMsg('Failed to export Excel. Please try again.');
//         setSnackbarSev('error');
//         setSnackbarOpen(true);
//       })
//       .finally(() => setExporting(false));
//   }, [selectedFe, buildParams, exporting]);

//   // ── Derived values
//   const s      = data?.summary || {};
//   const charts = data?.charts  || {};
//   const rawChartData = charts[chartMode] || [];

//   const chartData = rawChartData.map((row) => ({
//     label:     (row.day || row.month || '').split('T')[0],
//     Records:   row.count      || 0,
//     Deposited: row.deposited  || 0,
//     Returned:  row.returned   || 0,
//     Excess:    row.excess     || 0,
//   }));

//   const paymentChartData = rawChartData.map((row) => ({
//     label:        (row.day || row.month || '').split('T')[0],
//     'Agreed Amt': row.agreed_amount       || 0,
//     'Recovered':  row.recovered_amount    || 0,
//     'Agreed #':   row.agreed_to_pay_count || 0,
//   }));

//   // ── 3-category pie
//   const paymentPie = [
//     { name: 'Agreed',     value: s.agreed_to_pay     || 0, color: T.green  },
//     { name: 'Not Agreed', value: s.not_agreed_to_pay || 0, color: T.red    },
//     { name: 'Pending',    value: s.pending_payment   || 0, color: T.amber  },
//   ];

//   // ── Recovery rate — full decimal precision, no rounding
//   const recoveryRate = s.total_agreed_amount > 0
//     ? Math.min(100, ((s.total_recovered_amount / s.total_agreed_amount) * 100))
//     : 0;

//   // ──────────────────────────────────────────────────────────────
//   return (
//     <Box sx={{ minHeight: '100vh', background: T.pageBg, p: { xs: 2, md: 3 } }}>

//       {/* ── PAGE HEADER ── */}
//       <Box sx={{
//         display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
//         mb: 3,
//         opacity:   mounted ? 1 : 0,
//         transform: mounted ? 'none' : 'translateY(-10px)',
//         transition: 'all 0.5s ease',
//       }}>
//         <Box>
//           <Box display="flex" alignItems="center" gap={1.5}>
//             <Box sx={{
//               width: 10, height: 10, borderRadius: '50%',
//               background: loading ? T.amber : T.green,
//               boxShadow: loading ? `0 0 0 3px ${T.amberMid}` : `0 0 0 3px ${T.greenMid}`,
//               transition: 'all 0.3s',
//               animation: loading ? 'none' : 'hpulse 2.5s ease-in-out infinite',
//               '@keyframes hpulse': {
//                 '0%,100%': { boxShadow: `0 0 0 3px ${T.greenMid}` },
//                 '50%':     { boxShadow: `0 0 0 6px ${T.greenMid}55` },
//               },
//             }} />
//             <Typography sx={{
//               fontSize: { xs: 17, md: 21 },
//               fontWeight: 800, color: T.textPrimary, letterSpacing: -0.5,
//             }}>
//               CA — EPMS Dashboard
//             </Typography>
//             <Chip label="Live" size="small" sx={{
//               height: 20, fontSize: 10, fontWeight: 700,
//               bgcolor: T.greenSoft, color: T.green,
//               border: `1px solid ${T.greenMid}`,
//             }} />
//           </Box>
//           <Typography sx={{ fontSize: 12, color: T.textMuted, mt: 0.5 }}>
//             Excess Payment Management Intelligence
//             {lastRefreshed && ` · Refreshed at ${lastRefreshed.toLocaleTimeString()}`}
//           </Typography>
//         </Box>

//         {/* Action buttons */}
//         <Box display="flex" gap={1} alignItems="center">
//           {/* ── EXCEL DOWNLOAD BUTTON ── */}
//           <Tooltip title={selectedFe ? 'Download Excel Report' : 'Select an FE first'}>
//             <span>
//               <Box
//                 onClick={handleExport}
//                 sx={{
//                   display: 'flex', alignItems: 'center', gap: 0.75,
//                   px: 1.75, height: 36, borderRadius: '10px',
//                   background: (!selectedFe || exporting) ? T.graySoft : T.greenSoft,
//                   border: `1.5px solid ${(!selectedFe || exporting) ? T.grayMid : T.greenMid}`,
//                   color: (!selectedFe || exporting) ? T.textLight : T.green,
//                   cursor: (!selectedFe || exporting) ? 'not-allowed' : 'pointer',
//                   userSelect: 'none',
//                   transition: 'all 0.2s',
//                   '&:hover': (!selectedFe || exporting) ? {} : {
//                     background: T.greenMid,
//                     borderColor: T.green,
//                     transform: 'scale(1.03)',
//                   },
//                 }}
//               >
//                 {exporting
//                   ? <CircularProgress size={14} sx={{ color: T.green }} />
//                   : <DownloadIcon sx={{ fontSize: 16 }} />
//                 }
//                 <Typography sx={{ fontSize: 12, fontWeight: 700 }}>
//                   {exporting ? 'Exporting…' : 'Export Excel'}
//                 </Typography>
//               </Box>
//             </span>
//           </Tooltip>

//           {/* ── REFRESH BUTTON ── */}
//           <Tooltip title="Refresh Dashboard">
//             <span>
//               <IconButton
//                 onClick={fetchDashboard}
//                 disabled={loading || !selectedFe}
//                 size="small"
//                 sx={{
//                   color: T.blue, background: T.blueSoft,
//                   border: `1.5px solid ${T.blueMid}`,
//                   borderRadius: '10px', width: 36, height: 36,
//                   '&:hover': { background: T.blueMid, transform: 'scale(1.05)' },
//                   '& svg': {
//                     transition: 'transform 0.6s linear',
//                     transform: spinning ? 'rotate(360deg)' : 'rotate(0deg)',
//                   },
//                 }}
//               >
//                 <RefreshIcon fontSize="small" />
//               </IconButton>
//             </span>
//           </Tooltip>
//         </Box>
//       </Box>

//       {/* ── FILTER BAR ── */}
//       <Card delay={80} sx={{ p: 2, mb: 3 }}>
//         <Box display="flex" gap={2} alignItems="flex-end" flexWrap="wrap">
//           <Box display="flex" alignItems="center" gap={1} alignSelf="center">
//             <FilterIcon sx={{ color: T.textLight, fontSize: 16 }} />
//             <Typography sx={{
//               fontSize: 11, color: T.textLight,
//               textTransform: 'uppercase', letterSpacing: 1, fontWeight: 600,
//             }}>
//               Filters
//             </Typography>
//           </Box>

//           <FormControl size="small" sx={{ minWidth: 220 }}>
//             <InputLabel sx={{ fontSize: 12 }}>Select FE *</InputLabel>
//             <Select
//               value={selectedFe}
//               label="Select FE *"
//               onChange={(e) => setSelectedFe(e.target.value)}
//               sx={{ fontSize: 12, borderRadius: '10px' }}
//               displayEmpty
//             >
//               <MenuItem value="" disabled>
//                 <em style={{ color: T.textLight }}>— Please Select FE —</em>
//               </MenuItem>
//               {feList.map((fe) => (
//                 <MenuItem key={fe.id} value={fe.id} sx={{ fontSize: 12 }}>
//                   {fe.name || fe.name_of_fe || fe.id}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           <TextField
//             size="small" label="SHR Name" placeholder="Search SHR..."
//             value={shrName} onChange={(e) => setShrName(e.target.value)}
//             disabled={!selectedFe}
//             sx={{ minWidth: 180, '& .MuiOutlinedInput-root': { borderRadius: '10px', fontSize: 12 }, '& label': { fontSize: 12 } }}
//           />
//           <TextField
//             size="small" label="From Date" type="date"
//             value={startDate} onChange={(e) => setStartDate(e.target.value)}
//             InputLabelProps={{ shrink: true }} disabled={!selectedFe}
//             sx={{ minWidth: 160, '& .MuiOutlinedInput-root': { borderRadius: '10px', fontSize: 12 }, '& label': { fontSize: 12 } }}
//           />
//           <TextField
//             size="small" label="To Date" type="date"
//             value={endDate} onChange={(e) => setEndDate(e.target.value)}
//             InputLabelProps={{ shrink: true }} disabled={!selectedFe}
//             sx={{ minWidth: 160, '& .MuiOutlinedInput-root': { borderRadius: '10px', fontSize: 12 }, '& label': { fontSize: 12 } }}
//           />
//         </Box>
//       </Card>

//       {/* ── EMPTY STATE ── */}
//       {!selectedFe && (
//         <Box sx={{
//           display: 'flex', flexDirection: 'column',
//           alignItems: 'center', justifyContent: 'center',
//           py: 12, gap: 2,
//           opacity: mounted ? 1 : 0,
//           transform: mounted ? 'none' : 'translateY(12px)',
//           transition: 'all 0.5s ease',
//         }}>
//           <Box sx={{
//             width: 80, height: 80, borderRadius: '24px',
//             background: T.blueSoft, border: `2px dashed ${T.blueMid}`,
//             display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 1,
//           }}>
//             <AssessmentIcon sx={{ fontSize: 36, color: T.blue, opacity: 0.6 }} />
//           </Box>
//           <Typography sx={{ fontSize: 18, fontWeight: 700, color: T.textPrimary }}>
//             Select a Field Executive
//           </Typography>
//           <Typography sx={{ fontSize: 13, color: T.textMuted, textAlign: 'center', maxWidth: 340 }}>
//             Please choose an FE from the filter above to load the EPMS dashboard data.
//           </Typography>
//           <Box sx={{
//             mt: 1, display: 'flex', alignItems: 'center', gap: 1,
//             px: 2, py: 1, borderRadius: '10px',
//             background: T.blueSoft, border: `1.5px solid ${T.blueMid}`,
//           }}>
//             <Typography sx={{ fontSize: 12, color: T.blue, fontWeight: 600 }}>
//               ↑ Use the "Select FE" dropdown above
//             </Typography>
//           </Box>
//         </Box>
//       )}

//       {/* ══ DASHBOARD CONTENT ══ */}
//       {selectedFe && (
//         <>
//           {/* ── HERO METRICS ── */}
//           <Box sx={{
//             display: 'grid',
//             gridTemplateColumns: { xs: '1fr 1fr', sm: 'repeat(3,1fr)', md: 'repeat(6,1fr)' },
//             gap: 2, mb: 3,
//           }}>
//             <HeroCard label="Total Records"    value={s.total_records||0}           icon={AssessmentIcon}   gradient={T.gradBlue}   delay={100} />
//             <HeroCard label="Total Deposited"  value={s.total_deposited||0}          icon={BankIcon}         gradient={T.gradGreen}  format={fmt} delay={150} />
//             <HeroCard label="Total Returned"   value={s.total_returned||0}           icon={TrendingDownIcon} gradient={T.gradAmber}  format={fmt} delay={200} />
//             <HeroCard label="Excess Amount"    value={s.total_excess||0}             icon={TrendingUpIcon}   gradient={T.gradRed}    format={fmt} delay={250} />
//             <HeroCard label="Agreed Amount"    value={s.total_agreed_amount||0}      icon={WalletIcon}       gradient={T.gradTeal}   format={fmt} delay={300} />
//             <HeroCard label="Amount Recovered" value={s.total_recovered_amount||0}   icon={CheckIcon}        gradient={T.gradPurple} format={fmt} delay={350} />
//           </Box>

//           {/* ── CHARTS ROW ── */}
//           <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '2fr 1fr' }, gap: 2, mb: 3 }}>

//             {/* Area chart */}
//             <Card delay={400} sx={{ p: 3 }}>
//               <Box display="flex" justifyContent="space-between" alignItems="center" mb={2.5}>
//                 <Box display="flex" alignItems="center" gap={1}>
//                   <TimelineIcon sx={{ color: T.blue, fontSize: 18 }} />
//                   <Typography sx={{ fontSize: 13, fontWeight: 700, color: T.textPrimary }}>
//                     Amount &amp; Records Trend
//                   </Typography>
//                 </Box>
//                 <Box display="flex" gap={1}>
//                   <ToggleChip label="Daily"   active={chartMode === 'daily'}   onClick={() => setChartMode('daily')} />
//                   <ToggleChip label="Monthly" active={chartMode === 'monthly'} onClick={() => setChartMode('monthly')} />
//                 </Box>
//               </Box>
//               <Box display="flex" gap={2} mb={1.5} flexWrap="wrap">
//                 <LegendDot color={T.blue}  label="Records" />
//                 <LegendDot color={T.teal}  label="Deposited" />
//                 <LegendDot color={T.amber} label="Returned" />
//                 <LegendDot color={T.red}   label="Excess" />
//               </Box>
//               <ResponsiveContainer width="100%" height={220}>
//                 <AreaChart data={chartData} margin={{ top: 5, right: 5, bottom: 5, left: 0 }}>
//                   <defs>
//                     <linearGradient id="caGRec" x1="0" y1="0" x2="0" y2="1">
//                       <stop offset="5%"  stopColor={T.blue}  stopOpacity={0.18} />
//                       <stop offset="95%" stopColor={T.blue}  stopOpacity={0.01} />
//                     </linearGradient>
//                     <linearGradient id="caGDep" x1="0" y1="0" x2="0" y2="1">
//                       <stop offset="5%"  stopColor={T.teal}  stopOpacity={0.18} />
//                       <stop offset="95%" stopColor={T.teal}  stopOpacity={0.01} />
//                     </linearGradient>
//                     <linearGradient id="caGRet" x1="0" y1="0" x2="0" y2="1">
//                       <stop offset="5%"  stopColor={T.amber} stopOpacity={0.18} />
//                       <stop offset="95%" stopColor={T.amber} stopOpacity={0.01} />
//                     </linearGradient>
//                     <linearGradient id="caGExc" x1="0" y1="0" x2="0" y2="1">
//                       <stop offset="5%"  stopColor={T.red}   stopOpacity={0.18} />
//                       <stop offset="95%" stopColor={T.red}   stopOpacity={0.01} />
//                     </linearGradient>
//                   </defs>
//                   <CartesianGrid strokeDasharray="3 3" stroke={T.border} vertical={false} />
//                   <XAxis dataKey="label" tick={{ fill: T.textMuted, fontSize: 10 }} axisLine={false} tickLine={false} tickFormatter={(v) => String(v)?.slice(5) || v} />
//                   <YAxis yAxisId="left"  tick={{ fill: T.textMuted, fontSize: 10 }} axisLine={false} tickLine={false} />
//                   <YAxis yAxisId="right" tick={{ fill: T.textMuted, fontSize: 10 }} axisLine={false} tickLine={false} orientation="right" tickFormatter={(v) => fmt(v)} />
//                   <ReTooltip content={<CustomTooltip />} />
//                   <Area yAxisId="left"  type="monotone" dataKey="Records"   name="Records"   stroke={T.blue}  fill="url(#caGRec)" strokeWidth={2} dot={false} activeDot={{ r: 4, fill: T.blue }} />
//                   <Area yAxisId="right" type="monotone" dataKey="Deposited" name="Deposited" stroke={T.teal}  fill="url(#caGDep)" strokeWidth={2} dot={false} activeDot={{ r: 4, fill: T.teal }} />
//                   <Area yAxisId="right" type="monotone" dataKey="Returned"  name="Returned"  stroke={T.amber} fill="url(#caGRet)" strokeWidth={2} dot={false} activeDot={{ r: 4, fill: T.amber }} />
//                   <Area yAxisId="right" type="monotone" dataKey="Excess"    name="Excess"    stroke={T.red}   fill="url(#caGExc)" strokeWidth={2} dot={false} activeDot={{ r: 4, fill: T.red }} />
//                 </AreaChart>
//               </ResponsiveContainer>
//             </Card>

//             {/* Pie + Recovery */}
//             <Card delay={450} sx={{ p: 3 }}>
//               <Box display="flex" alignItems="center" gap={1} mb={2}>
//                 <PaymentIcon sx={{ color: T.amber, fontSize: 18 }} />
//                 <Typography sx={{ fontSize: 13, fontWeight: 700, color: T.textPrimary }}>
//                   Payment Agreement
//                 </Typography>
//               </Box>

//               <Box display="flex" flexDirection="column" alignItems="center">
//                 <ResponsiveContainer width="100%" height={150}>
//                   <PieChart>
//                     <Pie
//                       data={paymentPie} cx="50%" cy="50%"
//                       innerRadius={42} outerRadius={65}
//                       paddingAngle={4} dataKey="value"
//                       startAngle={90} endAngle={-270}
//                     >
//                       {paymentPie.map((entry, i) => (
//                         <Cell key={i} fill={entry.color} stroke={`${entry.color}30`} strokeWidth={2} />
//                       ))}
//                     </Pie>
//                     <ReTooltip contentStyle={{
//                       background: '#fff', border: `1px solid ${T.border}`,
//                       borderRadius: 8, fontSize: 12, boxShadow: T.shadow,
//                     }} />
//                   </PieChart>
//                 </ResponsiveContainer>

//                 <Box display="flex" gap={2} mt={0.5} flexWrap="wrap" justifyContent="center">
//                   {paymentPie.map((d) => (
//                     <Box key={d.name} display="flex" alignItems="center" gap={0.75}>
//                       <Box sx={{ width: 8, height: 8, borderRadius: '50%', background: d.color }} />
//                       <Typography sx={{ fontSize: 11, color: T.textSecondary }}>
//                         {d.name} ({d.value})
//                       </Typography>
//                     </Box>
//                   ))}
//                 </Box>
//               </Box>

//               {/* Recovery rate — 2 decimal precision, no rounding */}
//               <Box sx={{
//                 mt: 2, p: 1.5, borderRadius: '10px',
//                 background: T.greenSoft, border: `1.5px solid ${T.greenMid}`,
//               }}>
//                 <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.75}>
//                   <Typography sx={{ fontSize: 11, color: T.textSecondary, fontWeight: 600 }}>
//                     Recovery Rate
//                   </Typography>
//                   <Typography sx={{ fontSize: 14, color: T.green, fontWeight: 800 }}>
//                     {recoveryRate.toFixed(2)}%
//                   </Typography>
//                 </Box>
//                 <Box sx={{ height: 6, borderRadius: 3, background: `${T.greenMid}55` }}>
//                   <Box sx={{
//                     height: '100%', width: `${recoveryRate}%`,
//                     background: `linear-gradient(90deg,${T.green},#38A169)`,
//                     borderRadius: 3,
//                     transition: 'width 1.4s cubic-bezier(0.23,1,0.32,1)',
//                   }} />
//                 </Box>
//                 <Typography sx={{ fontSize: 10, color: T.textMuted, mt: 0.5 }}>
//                   {fmt(s.total_recovered_amount || 0)} of {fmt(s.total_agreed_amount || 0)}
//                 </Typography>
//               </Box>
//             </Card>
//           </Box>

//           {/* ── PAYMENT TREND CHART ── */}
//           <Card delay={480} sx={{ p: 3, mb: 3 }}>
//             <Box display="flex" justifyContent="space-between" alignItems="center" mb={2.5}>
//               <Box display="flex" alignItems="center" gap={1}>
//                 <WalletIcon sx={{ color: T.purple, fontSize: 18 }} />
//                 <Typography sx={{ fontSize: 13, fontWeight: 700, color: T.textPrimary }}>
//                   Agreed Amount vs Recovered — {chartMode === 'daily' ? 'Daily' : 'Monthly'}
//                 </Typography>
//               </Box>
//               <Box display="flex" gap={2}>
//                 <LegendDot color={T.teal}   label="Agreed Amt" />
//                 <LegendDot color={T.green}  label="Recovered" />
//                 <LegendDot color={T.purple} label="Agreed #" />
//               </Box>
//             </Box>
//             <ResponsiveContainer width="100%" height={200}>
//               <BarChart data={paymentChartData} margin={{ top: 5, right: 10, bottom: 5, left: 0 }} barSize={chartMode === 'daily' ? 8 : 22} barGap={3}>
//                 <defs>
//                   <linearGradient id="caBarAgreed" x1="0" y1="0" x2="0" y2="1">
//                     <stop offset="0%"   stopColor={T.teal}     stopOpacity={0.9} />
//                     <stop offset="100%" stopColor={T.tealMid}  stopOpacity={0.5} />
//                   </linearGradient>
//                   <linearGradient id="caBarRec" x1="0" y1="0" x2="0" y2="1">
//                     <stop offset="0%"   stopColor={T.green}    stopOpacity={0.9} />
//                     <stop offset="100%" stopColor={T.greenMid} stopOpacity={0.5} />
//                   </linearGradient>
//                   <linearGradient id="caBarAgrCount" x1="0" y1="0" x2="0" y2="1">
//                     <stop offset="0%"   stopColor={T.purple}    stopOpacity={0.9} />
//                     <stop offset="100%" stopColor={T.purpleMid} stopOpacity={0.5} />
//                   </linearGradient>
//                 </defs>
//                 <CartesianGrid strokeDasharray="3 3" stroke={T.border} vertical={false} />
//                 <XAxis dataKey="label" tick={{ fill: T.textMuted, fontSize: 10 }} axisLine={false} tickLine={false} tickFormatter={(v) => String(v)?.slice(5) || v} />
//                 <YAxis yAxisId="amt"   tick={{ fill: T.textMuted, fontSize: 10 }} axisLine={false} tickLine={false} tickFormatter={(v) => fmt(v)} />
//                 <YAxis yAxisId="count" tick={{ fill: T.textMuted, fontSize: 10 }} axisLine={false} tickLine={false} orientation="right" />
//                 <ReTooltip content={<CustomTooltip />} />
//                 <Bar yAxisId="amt"   dataKey="Agreed Amt" name="Agreed Amt" fill="url(#caBarAgreed)"   radius={[4,4,0,0]} />
//                 <Bar yAxisId="amt"   dataKey="Recovered"  name="Recovered"  fill="url(#caBarRec)"      radius={[4,4,0,0]} />
//                 <Bar yAxisId="count" dataKey="Agreed #"   name="Agreed #"   fill="url(#caBarAgrCount)" radius={[4,4,0,0]} />
//               </BarChart>
//             </ResponsiveContainer>
//           </Card>

//           {/* ── ORDER STATUS ── */}
//           <Card delay={500} sx={{ p: 3, mb: 3 }}>
//             <SectionHeader icon={GavelIcon} title="Order Status Overview" color={T.blue} colorBg={T.blueSoft} />
//             <Box sx={{
//               display: 'grid',
//               gridTemplateColumns: { xs: '1fr', sm: 'repeat(2,1fr)', md: 'repeat(4,1fr)' },
//               gap: 1.5,
//             }}>
//               <DualStatRow label="Freezing Order Issued"       yes={s.freezing_issued||0}            no={s.freezing_not_issued||0}            colorYes={T.blue}  colorNo={T.red}       delay={520} />
//               <DualStatRow label="Summons Issued"              yes={s.summons_issued||0}             no={s.summons_not_issued||0}             colorYes={T.amber} colorNo={T.textMuted} delay={560} />
//               <DualStatRow label="Bank Freezed"                yes={s.bank_freezed||0}               no={s.bank_not_freezed||0}               colorYes={T.red}   colorNo={T.textMuted} delay={600} />
//               <DualStatRow label="Partial Unfreeze Submitted"  yes={s.partial_unfreeze_submitted||0} no={s.partial_unfreeze_not_submitted||0} colorYes={T.teal}  colorNo={T.textMuted} delay={640} />
//               <DualStatRow label="Partial Unfreezed"           yes={s.partial_unfreezed||0}          no={s.partial_not_unfreezed||0}          colorYes={T.green} colorNo={T.textMuted} delay={680} />
//               <DualStatRow label="Defreezing Submitted"        yes={s.defreezing_submitted||0}       no={s.defreezing_not_submitted||0}       colorYes={T.amber} colorNo={T.textMuted} delay={720} />
//               <DualStatRow label="Bank De-freezed"             yes={s.bank_defreezed||0}             no={s.bank_not_defreezed||0}             colorYes={T.green} colorNo={T.textMuted} delay={760} />
//             </Box>
//           </Card>

//           {/* ── DOCS + PAYMENT ── */}
//           <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2, mb: 3 }}>

//             {/* Document Status */}
//             <Card delay={800} sx={{ p: 3 }}>
//               <SectionHeader icon={DocsIcon} title="Document Status" color={T.teal} colorBg={T.tealSoft} />
//               <Box display="flex" flexDirection="column" gap={1.5}>
//                 <DualStatRow label="Affidavit Submitted"      yes={s.affidavit_submitted||0}      no={s.affidavit_not_submitted||0}      colorYes={T.teal}  colorNo={T.red} delay={820} />
//                 <DualStatRow label="Bank Statement Submitted" yes={s.bank_statement_submitted||0} no={s.bank_statement_not_submitted||0} colorYes={T.blue}  colorNo={T.red} delay={860} />
//                 <DualStatRow label="PAN Card Submitted"       yes={s.pan_submitted||0}            no={s.pan_not_submitted||0}            colorYes={T.amber} colorNo={T.red} delay={900} />
//               </Box>
//             </Card>

//             {/* Payment Breakdown */}
//             <Card delay={820} sx={{ p: 3 }}>
//               <SectionHeader icon={PaymentIcon} title="Payment Breakdown" color={T.amber} colorBg={T.amberSoft} />

//               <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 1.5, mb: 2 }}>
//                 <StatMini
//                   label="Agreed"
//                   value={s.agreed_to_pay || 0}
//                   total={s.total_records || 1}
//                   color={T.green}
//                   softColor={T.greenSoft}
//                   delay={840}
//                 />
//                 <StatMini
//                   label="Not Agreed"
//                   value={s.not_agreed_to_pay || 0}
//                   total={s.total_records || 1}
//                   color={T.red}
//                   softColor={T.redSoft}
//                   delay={880}
//                 />
//                 <StatMini
//                   label="Pending"
//                   value={s.pending_payment || 0}
//                   total={s.total_records || 1}
//                   color={T.amber}
//                   softColor={T.amberSoft}
//                   delay={920}
//                 />
//               </Box>

//               {/* Amount Flow */}
//               <Box sx={{
//                 p: 2, borderRadius: '10px',
//                 background: T.cardBgAlt, border: `1.5px solid ${T.border}`,
//               }}>
//                 <Typography sx={{
//                   fontSize: 11, color: T.textMuted, textTransform: 'uppercase',
//                   letterSpacing: 1, fontWeight: 600, mb: 1.5,
//                 }}>
//                   Amount Flow
//                 </Typography>
//                 {[
//                   { label: 'Total Excess',   value: s.total_excess||0,            color: T.red,   softColor: `${T.redMid}40`   },
//                   { label: 'Agreed Amount',  value: s.total_agreed_amount||0,     color: T.amber, softColor: `${T.amberMid}40` },
//                   { label: 'Recovered',      value: s.total_recovered_amount||0,  color: T.green, softColor: `${T.greenMid}40` },
//                 ].map((item, i) => (
//                   <AmountBar key={i} {...item} maxVal={s.total_excess || 1} delay={900 + i * 60} />
//                 ))}
//               </Box>
//             </Card>
//           </Box>

//           {/* ── BAR CHART — Record Count ── */}
//           <Card delay={1000} sx={{ p: 3 }}>
//             <Box display="flex" justifyContent="space-between" alignItems="center" mb={2.5}>
//               <Box display="flex" alignItems="center" gap={1}>
//                 <AssessmentIcon sx={{ color: T.blue, fontSize: 18 }} />
//                 <Typography sx={{ fontSize: 13, fontWeight: 700, color: T.textPrimary }}>
//                   Record Count — {chartMode === 'daily' ? 'Daily' : 'Monthly'} Bar View
//                 </Typography>
//               </Box>
//               <Box display="flex" alignItems="center" gap={0.75}>
//                 <Box sx={{ width: 10, height: 10, borderRadius: 1, background: T.blue }} />
//                 <Typography sx={{ fontSize: 11, color: T.textMuted }}>Records per period</Typography>
//               </Box>
//             </Box>
//             <ResponsiveContainer width="100%" height={180}>
//               <BarChart data={chartData} margin={{ top: 5, right: 10, bottom: 5, left: 0 }} barSize={chartMode === 'daily' ? 10 : 28}>
//                 <defs>
//                   <linearGradient id="caBarGrad" x1="0" y1="0" x2="0" y2="1">
//                     <stop offset="0%"   stopColor={T.blue}    stopOpacity={0.9} />
//                     <stop offset="100%" stopColor={T.blueMid} stopOpacity={0.5} />
//                   </linearGradient>
//                 </defs>
//                 <CartesianGrid strokeDasharray="3 3" stroke={T.border} vertical={false} />
//                 <XAxis dataKey="label" tick={{ fill: T.textMuted, fontSize: 10 }} axisLine={false} tickLine={false} tickFormatter={(v) => String(v)?.slice(5) || v} />
//                 <YAxis tick={{ fill: T.textMuted, fontSize: 10 }} axisLine={false} tickLine={false} />
//                 <ReTooltip content={<CustomTooltip />} />
//                 <Bar dataKey="Records" fill="url(#caBarGrad)" radius={[5, 5, 0, 0]} />
//               </BarChart>
//             </ResponsiveContainer>
//           </Card>
//         </>
//       )}

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMsg}
//         severity={snackbarSev}
//         onClose={() => setSnackbarOpen(false)}
//       />
//     </Box>
//   );
// };

// export default CaDashboardComponent;


import React, { useEffect, useState, useCallback, useRef } from 'react';
import {
  Box, Typography, FormControl, InputLabel, Autocomplete,
  Tooltip, IconButton, Chip, TextField, CircularProgress,
} from '@mui/material';
import {
  AccountBalance as BankIcon, Gavel as GavelIcon, Description as DocsIcon,
  Payments as PaymentIcon, FilterList as FilterIcon, Refresh as RefreshIcon,
  TrendingUp as TrendingUpIcon, TrendingDown as TrendingDownIcon,
  Assessment as AssessmentIcon, CheckCircle as CheckIcon,
  Cancel as CancelIcon, Timeline as TimelineIcon,
  AccountBalanceWallet as WalletIcon, FileDownload as DownloadIcon,
  Balance as ScaleIcon,
} from '@mui/icons-material';
import {
  AreaChart, Area, BarChart, Bar, XAxis, YAxis, CartesianGrid,
  Tooltip as ReTooltip, ResponsiveContainer, PieChart, Pie, Cell,
} from 'recharts';
import api from '../../../api/axiosInterceptor';
import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
import { fetchMyFeList, fetchMyShrList, STAGE_LABELS } from './workflowApi';

// ─────────────────────────────────────────────
// DESIGN TOKENS — matches the original EPMS dashboards
// ─────────────────────────────────────────────
const T = {
  pageBg: '#F0F4F8', cardBg: '#FFFFFF', cardBgAlt: '#F7FAFC',
  border: '#E2E8F0', borderHov: '#CBD5E0',
  shadow: '0 1px 4px rgba(0,0,0,0.06),0 4px 16px rgba(0,0,0,0.06)',
  shadowHov: '0 8px 32px rgba(0,0,0,0.12),0 2px 8px rgba(0,0,0,0.06)',
  shadowHero: '0 4px 20px rgba(0,0,0,0.10)',

  blue: '#3182CE', blueSoft: '#EBF8FF', blueMid: '#BEE3F8',
  teal: '#2C7A7B', tealSoft: '#E6FFFA', tealMid: '#81E6D9',
  green: '#276749', greenSoft: '#F0FFF4', greenMid: '#9AE6B4',
  red: '#C53030', redSoft: '#FFF5F5', redMid: '#FEB2B2',
  amber: '#C05621', amberSoft: '#FFFAF0', amberMid: '#FBD38D',
  purple: '#553C9A', purpleSoft: '#FAF5FF', purpleMid: '#D6BCFA',
  gray: '#4A5568', graySoft: '#EDF2F7', grayMid: '#CBD5E0',

  gradBlue: 'linear-gradient(135deg,#2B6CB0 0%,#3182CE 100%)',
  gradGreen: 'linear-gradient(135deg,#276749 0%,#38A169 100%)',
  gradRed: 'linear-gradient(135deg,#9B2C2C 0%,#C53030 100%)',
  gradAmber: 'linear-gradient(135deg,#9C4221 0%,#DD6B20 100%)',
  gradTeal: 'linear-gradient(135deg,#285E61 0%,#319795 100%)',
  gradPurple: 'linear-gradient(135deg,#44337A 0%,#6B46C1 100%)',

  textPrimary: '#1A202C', textSecondary: '#4A5568',
  textMuted: '#718096', textLight: '#A0AEC0',
};

const fmt = (n) => {
  n = Number(n) || 0;
  if (n >= 1_00_00_000) return `₹${(n / 1_00_00_000).toFixed(4)} Cr`;
  if (n >= 1_00_000) return `₹${(n / 1_00_000).toFixed(4)} L`;
  return `₹${n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

// ─────────────────────────────────────────────
// ANIMATED NUMBER
// ─────────────────────────────────────────────
const AnimatedNumber = ({ value, format, duration = 1200 }) => {
  const [display, setDisplay] = useState(0);
  const rafRef = useRef();
  const prevVal = useRef(0);

  useEffect(() => {
    const from = prevVal.current;
    const to = Number(value) || 0;
    prevVal.current = to;
    const start = Date.now();
    const tick = () => {
      const p = Math.min((Date.now() - start) / duration, 1);
      const ease = 1 - Math.pow(1 - p, 4);
      setDisplay(from + (to - from) * ease);
      if (p < 1) rafRef.current = requestAnimationFrame(tick);
    };
    cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, [value]);

  if (format) return <span>{format(display)}</span>;
  return (
    <span>
      {display === (Number(value) || 0)
        ? (Number(value) || 0).toLocaleString('en-IN')
        : Math.floor(display).toLocaleString('en-IN')}
    </span>
  );
};

// ─────────────────────────────────────────────
// BASE CARD
// ─────────────────────────────────────────────
const Card = ({ children, sx = {}, delay = 0 }) => {
  const [hovered, setHovered] = useState(false);
  const [visible, setVisible] = useState(false);
  useEffect(() => { const t = setTimeout(() => setVisible(true), delay); return () => clearTimeout(t); }, [delay]);
  return (
    <Box
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      sx={{
        background: T.cardBg, borderRadius: '14px',
        border: `1.5px solid ${hovered ? T.borderHov : T.border}`,
        boxShadow: hovered ? T.shadowHov : T.shadow,
        transition: 'all 0.3s cubic-bezier(0.23,1,0.32,1)',
        transform: visible ? (hovered ? 'translateY(-3px)' : 'translateY(0)') : 'translateY(16px)',
        opacity: visible ? 1 : 0, overflow: 'hidden', ...sx,
      }}
    >
      {children}
    </Box>
  );
};

// ─────────────────────────────────────────────
// HERO METRIC CARD
// ─────────────────────────────────────────────
const HeroCard = ({ label, value, icon: Icon, gradient, format, delay }) => {
  const [hovered, setHovered] = useState(false);
  const [visible, setVisible] = useState(false);
  useEffect(() => { const t = setTimeout(() => setVisible(true), delay); return () => clearTimeout(t); }, [delay]);
  return (
    <Box
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      sx={{
        background: gradient, borderRadius: '14px', p: 2.5, position: 'relative', overflow: 'hidden',
        boxShadow: hovered ? '0 12px 40px rgba(0,0,0,0.2)' : T.shadowHero,
        transition: 'all 0.35s cubic-bezier(0.23,1,0.32,1)',
        transform: visible ? (hovered ? 'translateY(-4px) scale(1.02)' : 'translateY(0) scale(1)') : 'translateY(20px) scale(0.97)',
        opacity: visible ? 1 : 0,
      }}
    >
      <Box sx={{ position: 'absolute', right: -20, top: -20, width: 100, height: 100, borderRadius: '50%', background: 'rgba(255,255,255,0.08)', transform: hovered ? 'scale(1.2)' : 'scale(1)', transition: 'transform 0.4s' }} />
      <Box sx={{ position: 'absolute', right: 16, top: 16, width: 44, height: 44, borderRadius: '50%', background: 'rgba(255,255,255,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Icon sx={{ color: '#fff', fontSize: 20 }} />
      </Box>
      <Typography sx={{ fontSize: 10, color: 'rgba(255,255,255,0.75)', textTransform: 'uppercase', letterSpacing: 1.2, mb: 1 }}>{label}</Typography>
      <Typography sx={{ fontSize: 24, fontWeight: 800, color: '#fff', lineHeight: 1 }}>
        <AnimatedNumber value={value} format={format} />
      </Typography>
      <Box sx={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 3, background: 'rgba(255,255,255,0.2)' }} />
    </Box>
  );
};

// ─────────────────────────────────────────────
// SECTION HEADER
// ─────────────────────────────────────────────
const SectionHeader = ({ icon: Icon, title, color, colorBg }) => (
  <Box display="flex" alignItems="center" gap={1.5} mb={2.5}>
    <Box sx={{ width: 34, height: 34, borderRadius: '10px', background: colorBg || `${color}18`, border: `1.5px solid ${color}35`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
      <Icon sx={{ color, fontSize: 17 }} />
    </Box>
    <Typography sx={{ fontSize: 12, fontWeight: 700, color: T.textPrimary, textTransform: 'uppercase', letterSpacing: 1.5 }}>{title}</Typography>
    <Box sx={{ flex: 1, height: '1.5px', background: `linear-gradient(90deg,${color}40,transparent)` }} />
  </Box>
);

// ─────────────────────────────────────────────
// DUAL STAT ROW (2-state, yes/no)
// ─────────────────────────────────────────────
const DualStatRow = ({ label, yes, no, colorYes = T.green, colorNo = T.red, delay }) => {
  const total = (yes + no) || 1;
  const pct = Math.round((yes / total) * 100);
  const [visible, setVisible] = useState(false);
  useEffect(() => { const t = setTimeout(() => setVisible(true), delay + 200); return () => clearTimeout(t); }, [delay]);
  return (
    <Box sx={{ p: 1.5, borderRadius: '10px', background: T.cardBgAlt, border: `1.5px solid ${T.border}`, transition: 'border-color 0.2s', '&:hover': { borderColor: `${colorYes}55` } }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography sx={{ fontSize: 11, color: T.textSecondary, fontWeight: 500 }}>{label}</Typography>
        <Box display="flex" gap={0.75}>
          <Chip icon={<CheckIcon sx={{ fontSize: '11px !important', color: `${colorYes} !important` }} />} label={yes} size="small" sx={{ height: 20, fontSize: 11, fontWeight: 700, bgcolor: `${colorYes}15`, color: colorYes, border: `1px solid ${colorYes}35`, '& .MuiChip-label': { px: 0.75 } }} />
          <Chip icon={<CancelIcon sx={{ fontSize: '11px !important', color: `${colorNo} !important` }} />} label={no} size="small" sx={{ height: 20, fontSize: 11, fontWeight: 700, bgcolor: `${colorNo}12`, color: colorNo, border: `1px solid ${colorNo}30`, '& .MuiChip-label': { px: 0.75 } }} />
        </Box>
      </Box>
      <Box sx={{ height: 5, borderRadius: 3, background: `${colorNo}20`, overflow: 'hidden' }}>
        <Box sx={{ height: '100%', width: visible ? `${pct}%` : '0%', background: `linear-gradient(90deg,${colorYes},${colorYes}bb)`, borderRadius: 3, transition: 'width 1.3s cubic-bezier(0.23,1,0.32,1)', boxShadow: `2px 0 8px ${colorYes}44` }} />
      </Box>
    </Box>
  );
};

// ─────────────────────────────────────────────
// TRI STAT ROW (3-state — waiting / delivered / returned)
// ─────────────────────────────────────────────
const TriStatRow = ({ label, waiting, delivered, returned, delay }) => {
  const total = (waiting + delivered + returned) || 1;
  const [visible, setVisible] = useState(false);
  useEffect(() => { const t = setTimeout(() => setVisible(true), delay + 200); return () => clearTimeout(t); }, [delay]);
  const segs = [
    { key: 'Delivered', v: delivered, color: T.green },
    { key: 'Returned', v: returned, color: T.red },
    { key: 'Waiting', v: waiting, color: T.gray },
  ];
  return (
    <Box sx={{ p: 1.5, borderRadius: '10px', background: T.cardBgAlt, border: `1.5px solid ${T.border}` }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography sx={{ fontSize: 11, color: T.textSecondary, fontWeight: 500 }}>{label}</Typography>
        <Box display="flex" gap={0.75}>
          {segs.map((s) => (
            <Chip key={s.key} label={`${s.key}: ${s.v}`} size="small" sx={{ height: 20, fontSize: 10, fontWeight: 700, bgcolor: `${s.color}15`, color: s.color, border: `1px solid ${s.color}35` }} />
          ))}
        </Box>
      </Box>
      <Box display="flex" sx={{ height: 5, borderRadius: 3, overflow: 'hidden', bgcolor: T.graySoft }}>
        {segs.map((s) => (
          <Box key={s.key} sx={{ height: '100%', width: visible ? `${(s.v / total) * 100}%` : '0%', background: s.color, transition: 'width 1.3s cubic-bezier(0.23,1,0.32,1)' }} />
        ))}
      </Box>
    </Box>
  );
};

// ─────────────────────────────────────────────
// STAT MINI
// ─────────────────────────────────────────────
const StatMini = ({ label, value, total, color, softColor, delay }) => {
  const pct = total > 0 ? Math.round((value / total) * 100) : 0;
  const [visible, setVisible] = useState(false);
  useEffect(() => { const t = setTimeout(() => setVisible(true), delay + 200); return () => clearTimeout(t); }, [delay]);
  return (
    <Box sx={{ p: 2, borderRadius: '12px', background: softColor, border: `1.5px solid ${color}30` }}>
      <Typography sx={{ fontSize: 10, color, textTransform: 'uppercase', letterSpacing: 1, fontWeight: 700, mb: 0.5 }}>{label}</Typography>
      <Typography sx={{ fontSize: 24, fontWeight: 800, color: T.textPrimary, lineHeight: 1 }}><AnimatedNumber value={value} /></Typography>
      <Box sx={{ mt: 1.25, height: 4, borderRadius: 2, background: `${color}20` }}>
        <Box sx={{ height: '100%', width: visible ? `${pct}%` : '0%', background: color, borderRadius: 2, transition: 'width 1.3s cubic-bezier(0.23,1,0.32,1)' }} />
      </Box>
      <Typography sx={{ fontSize: 10, color, fontWeight: 600, mt: 0.5 }}>{pct}% of total</Typography>
    </Box>
  );
};

// ─────────────────────────────────────────────
// AMOUNT BAR
// ─────────────────────────────────────────────
const AmountBar = ({ label, value, maxVal, color, softColor, delay }) => {
  const pct = maxVal > 0 ? Math.min(100, Math.round((value / maxVal) * 100)) : 0;
  const [visible, setVisible] = useState(false);
  useEffect(() => { const t = setTimeout(() => setVisible(true), delay + 200); return () => clearTimeout(t); }, [delay]);
  return (
    <Box mb={1.75}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.6}>
        <Box display="flex" alignItems="center" gap={0.75}>
          <Box sx={{ width: 8, height: 8, borderRadius: '50%', background: color, flexShrink: 0 }} />
          <Typography sx={{ fontSize: 12, color: T.textSecondary }}>{label}</Typography>
        </Box>
        <Typography sx={{ fontSize: 12, color, fontWeight: 700 }}>{fmt(value)}</Typography>
      </Box>
      <Box sx={{ height: 6, borderRadius: 3, background: softColor || `${color}20`, overflow: 'hidden' }}>
        <Box sx={{ height: '100%', width: visible ? `${pct}%` : '0%', background: `linear-gradient(90deg,${color}cc,${color})`, borderRadius: 3, transition: 'width 1.4s cubic-bezier(0.23,1,0.32,1)' }} />
      </Box>
    </Box>
  );
};

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  const amountKeys = new Set(['Deposited', 'Returned', 'Excess', 'Agreed Amt', 'Recovered']);
  return (
    <Box sx={{ background: '#fff', border: `1.5px solid ${T.border}`, borderRadius: '10px', p: 1.5, boxShadow: '0 8px 24px rgba(0,0,0,0.12)', minWidth: 160 }}>
      <Typography sx={{ fontSize: 11, color: T.textMuted, mb: 0.75 }}>{label}</Typography>
      {payload.map((p, i) => (
        <Typography key={i} sx={{ fontSize: 12, color: p.color, fontWeight: 700 }}>
          {p.name}: {amountKeys.has(p.name) ? fmt(p.value) : p.value}
        </Typography>
      ))}
    </Box>
  );
};

const ToggleChip = ({ label, active, onClick }) => (
  <Chip label={label} size="small" onClick={onClick} sx={{ height: 24, fontSize: 11, fontWeight: 600, cursor: 'pointer', bgcolor: active ? T.blue : 'transparent', color: active ? '#fff' : T.textMuted, border: `1.5px solid ${active ? T.blue : T.border}`, transition: 'all 0.2s', '&:hover': { bgcolor: active ? T.blue : T.pageBg } }} />
);

const LegendDot = ({ color, label }) => (
  <Box display="flex" alignItems="center" gap={0.75}>
    <Box sx={{ width: 10, height: 10, borderRadius: 1, background: color }} />
    <Typography sx={{ fontSize: 11, color: T.textMuted }}>{label}</Typography>
  </Box>
);

const WORKFLOW_PIE_COLORS = [T.blue, T.purple, T.gray];
const STAGE_BAR_COLORS = [T.gray, T.purple, T.blue, T.blueMid, T.amber, T.amberMid, T.teal, T.green, '#22543D'];

// ─────────────────────────────────────────────
// MAIN DASHBOARD
// ─────────────────────────────────────────────
export const CaDashboardComponent = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [feList, setFeList] = useState([]);
  const [selectedFe, setSelectedFe] = useState('');
  const [shrOptions, setShrOptions] = useState([]);
  const [shrName, setShrName] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [chartMode, setChartMode] = useState('daily');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState('');
  const [snackbarSev, setSnackbarSev] = useState('info');
  const [lastRefreshed, setLastRefreshed] = useState(null);
  const [spinning, setSpinning] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => { setTimeout(() => setMounted(true), 80); }, []);
  useEffect(() => { fetchMyFeList().then((r) => setFeList(r.data?.results || [])).catch(() => setFeList([])); }, []);

  useEffect(() => {
    if (!selectedFe) { setShrOptions([]); setShrName(''); return; }
    fetchMyShrList(selectedFe).then((r) => setShrOptions(r.data?.results || [])).catch(() => setShrOptions([]));
    setShrName('');
  }, [selectedFe]);

  const buildParams = useCallback(() => {
    const p = new URLSearchParams();
    if (selectedFe) p.append('fe', selectedFe);
    if (shrName) p.append('shr_name', shrName);
    if (startDate) p.append('start_date', startDate);
    if (endDate) p.append('end_date', endDate);
    return p.toString();
  }, [selectedFe, shrName, startDate, endDate]);

  const fetchDashboard = useCallback(() => {
    if (!selectedFe) return;
    setLoading(true); setSpinning(true);
    api.get(`/excess_payment_mgmt/ca-epms-dashboard/?${buildParams()}`)
      .then((r) => {
        setData(r.data); setLastRefreshed(new Date());
        setSnackbarMsg('Dashboard refreshed successfully'); setSnackbarSev('success'); setSnackbarOpen(true);
      })
      .catch(() => { setSnackbarMsg('Failed to load dashboard data'); setSnackbarSev('error'); setSnackbarOpen(true); })
      .finally(() => { setLoading(false); setTimeout(() => setSpinning(false), 500); });
  }, [selectedFe, buildParams]);

  useEffect(() => { if (!selectedFe) { setData(null); return; } fetchDashboard(); }, [selectedFe, fetchDashboard]);

  const handleExport = useCallback(() => {
    if (!selectedFe || exporting) return;
    setExporting(true);
    setSnackbarMsg('Preparing Excel export…'); setSnackbarSev('info'); setSnackbarOpen(true);
    api.get(`/excess_payment_mgmt/ca-epms-dashboard/export/?${buildParams()}`, { responseType: 'blob' })
      .then((response) => {
        const disposition = response.headers?.['content-disposition'] || '';
        const match = disposition.match(/filename="?([^"]+)"?/);
        const filename = match ? match[1] : `CA_EPMS_${new Date().toISOString().slice(0, 10)}.xlsx`;
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url; link.setAttribute('download', filename);
        document.body.appendChild(link); link.click(); link.remove();
        window.URL.revokeObjectURL(url);
        setSnackbarMsg('Excel file downloaded successfully'); setSnackbarSev('success'); setSnackbarOpen(true);
      })
      .catch(() => { setSnackbarMsg('Failed to export Excel. Please try again.'); setSnackbarSev('error'); setSnackbarOpen(true); })
      .finally(() => setExporting(false));
  }, [selectedFe, buildParams, exporting]);

  const s = data?.summary || {};
  const charts = data?.charts || {};
  const rawChartData = charts[chartMode] || [];

  const chartData = rawChartData.map((row) => ({
    label: (row.period || '').split('T')[0], Records: row.count || 0,
    Deposited: row.deposited || 0, Returned: row.returned || 0, Excess: row.excess || 0,
  }));
  const paymentChartData = rawChartData.map((row) => ({
    label: (row.period || '').split('T')[0], 'Agreed Amt': row.agreed_amount || 0,
    Recovered: row.recovered_amount || 0, 'Agreed #': row.agreed_to_pay_count || 0,
  }));

  const workflowPie = [
    { name: 'Workflow 1(Agreed to Pay)', value: s.workflow_1_count || 0, color: T.blue },
    { name: 'Workflow 2(Objection to Pay)', value: s.workflow_2_count || 0, color: T.purple },
    { name: 'Not Decided', value: s.workflow_undecided_count || 0, color: T.gray },
  ];
  const paymentPie = [
    { name: 'Agreed', value: s.agreed_to_pay || 0, color: T.green },
    { name: 'Not Agreed', value: s.not_agreed_to_pay || 0, color: T.red },
    { name: 'Pending', value: s.pending_payment_decision || 0, color: T.amber },
  ];

  const stageLabelMap = STAGE_LABELS || {};
  const stageEntries = Object.entries(s.stage_breakdown || {});
  const stageChartData = stageEntries.map(([stage, count]) => ({ stage: stageLabelMap[stage] || stage, count }));

  const recoveryRate = s.total_payable_forensic_adjusted > 0
    ? Math.min(100, (s.total_recovered_amount / s.total_payable_forensic_adjusted) * 100) : 0;

  return (
    <Box sx={{ minHeight: '100vh', background: T.pageBg, p: { xs: 2, md: 3 } }}>
      {/* HEADER */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3, opacity: mounted ? 1 : 0, transform: mounted ? 'none' : 'translateY(-10px)', transition: 'all 0.5s ease' }}>
        <Box>
          <Box display="flex" alignItems="center" gap={1.5}>
            <Box sx={{ width: 10, height: 10, borderRadius: '50%', background: loading ? T.amber : T.green, boxShadow: loading ? `0 0 0 3px ${T.amberMid}` : `0 0 0 3px ${T.greenMid}`, animation: loading ? 'none' : 'hpulse 2.5s ease-in-out infinite', '@keyframes hpulse': { '0%,100%': { boxShadow: `0 0 0 3px ${T.greenMid}` }, '50%': { boxShadow: `0 0 0 6px ${T.greenMid}55` } } }} />
            <Typography sx={{ fontSize: { xs: 17, md: 21 }, fontWeight: 800, color: T.textPrimary, letterSpacing: -0.5 }}>CA — EPMS Dashboard</Typography>
            <Chip label="Live" size="small" sx={{ height: 20, fontSize: 10, fontWeight: 700, bgcolor: T.greenSoft, color: T.green, border: `1px solid ${T.greenMid}` }} />
          </Box>
          <Typography sx={{ fontSize: 12, color: T.textMuted, mt: 0.5 }}>
            Excess Payment Management Intelligence{lastRefreshed && ` · Refreshed at ${lastRefreshed.toLocaleTimeString()}`}
          </Typography>
        </Box>
        <Box display="flex" gap={1} alignItems="center">
          <Tooltip title={selectedFe ? 'Download Excel Report' : 'Select an FE first'}>
            <span>
              <Box onClick={handleExport} sx={{ display: 'flex', alignItems: 'center', gap: 0.75, px: 1.75, height: 36, borderRadius: '10px', background: (!selectedFe || exporting) ? T.graySoft : T.greenSoft, border: `1.5px solid ${(!selectedFe || exporting) ? T.grayMid : T.greenMid}`, color: (!selectedFe || exporting) ? T.textLight : T.green, cursor: (!selectedFe || exporting) ? 'not-allowed' : 'pointer', '&:hover': (!selectedFe || exporting) ? {} : { background: T.greenMid, borderColor: T.green, transform: 'scale(1.03)' } }}>
                {exporting ? <CircularProgress size={14} sx={{ color: T.green }} /> : <DownloadIcon sx={{ fontSize: 16 }} />}
                <Typography sx={{ fontSize: 12, fontWeight: 700 }}>{exporting ? 'Exporting…' : 'Export Excel'}</Typography>
              </Box>
            </span>
          </Tooltip>
          <Tooltip title="Refresh Dashboard">
            <span>
              <IconButton onClick={fetchDashboard} disabled={loading || !selectedFe} size="small" sx={{ color: T.blue, background: T.blueSoft, border: `1.5px solid ${T.blueMid}`, borderRadius: '10px', width: 36, height: 36, '&:hover': { background: T.blueMid, transform: 'scale(1.05)' }, '& svg': { transition: 'transform 0.6s linear', transform: spinning ? 'rotate(360deg)' : 'rotate(0deg)' } }}>
                <RefreshIcon fontSize="small" />
              </IconButton>
            </span>
          </Tooltip>
        </Box>
      </Box>

      {/* FILTERS */}
      <Card delay={80} sx={{ p: 2, mb: 3 }}>
        <Box display="flex" gap={2} alignItems="flex-end" flexWrap="wrap">
          <Box display="flex" alignItems="center" gap={1} alignSelf="center">
            <FilterIcon sx={{ color: T.textLight, fontSize: 16 }} />
            <Typography sx={{ fontSize: 11, color: T.textLight, textTransform: 'uppercase', letterSpacing: 1, fontWeight: 600 }}>Filters</Typography>
          </Box>
          <Autocomplete
            size="small"
            sx={{ minWidth: 260, '& .MuiInputBase-root': { borderRadius: '10px', fontSize: 12 } }}
            options={feList}
            getOptionLabel={(fe) => fe.name || ''}
            isOptionEqualToValue={(opt, val) => opt.id === val.id}
            value={feList.find((fe) => fe.id === selectedFe) || null}
            onChange={(_, val) => setSelectedFe(val ? val.id : '')}
            renderInput={(params) => (
              <TextField {...params} label="Select FE *" placeholder="Type to search your FEs..." InputLabelProps={{ ...params.InputLabelProps, sx: { fontSize: 12 } }} />
            )}
          />
          <Autocomplete
            size="small"
            sx={{ minWidth: 220, '& .MuiInputBase-root': { borderRadius: '10px', fontSize: 12 } }}
            options={shrOptions}
            getOptionLabel={(o) => o.name || o.shr_name || ''}
            isOptionEqualToValue={(opt, val) => opt.id === val.id}
            value={shrOptions.find((o) => (o.name || o.shr_name) === shrName) || null}
            onChange={(_, val) => setShrName(val ? (val.name || val.shr_name) : '')}
            disabled={!selectedFe}
            renderInput={(params) => (
              <TextField {...params} label="SHR / Shirastedar" placeholder="Search Shirastedar..." InputLabelProps={{ ...params.InputLabelProps, sx: { fontSize: 12 } }} />
            )}
          />
          <TextField size="small" label="From Date" type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} InputLabelProps={{ shrink: true }} disabled={!selectedFe} sx={{ minWidth: 160, '& .MuiOutlinedInput-root': { borderRadius: '10px', fontSize: 12 }, '& label': { fontSize: 12 } }} />
          <TextField size="small" label="To Date" type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} InputLabelProps={{ shrink: true }} disabled={!selectedFe} sx={{ minWidth: 160, '& .MuiOutlinedInput-root': { borderRadius: '10px', fontSize: 12 }, '& label': { fontSize: 12 } }} />
        </Box>
      </Card>

      {!selectedFe && (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', py: 12, gap: 2, opacity: mounted ? 1 : 0, transform: mounted ? 'none' : 'translateY(12px)', transition: 'all 0.5s ease' }}>
          <Box sx={{ width: 80, height: 80, borderRadius: '24px', background: T.blueSoft, border: `2px dashed ${T.blueMid}`, display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 1 }}>
            <AssessmentIcon sx={{ fontSize: 36, color: T.blue, opacity: 0.6 }} />
          </Box>
          <Typography sx={{ fontSize: 18, fontWeight: 700, color: T.textPrimary }}>Select a Financial Establishment</Typography>
          <Typography sx={{ fontSize: 13, color: T.textMuted, textAlign: 'center', maxWidth: 340 }}>
            Choose one of your assigned FEs above to load the EPMS dashboard.
          </Typography>
        </Box>
      )}

      {selectedFe && (
        <>
          {/* HERO METRICS */}
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr 1fr', sm: 'repeat(3,1fr)', md: 'repeat(5,1fr)' }, gap: 2, mb: 2 }}>
            <HeroCard label="Total Records" value={s.total_records || 0} icon={AssessmentIcon} gradient={T.gradBlue} delay={100} />
            <HeroCard label="Total Deposited" value={s.total_deposited || 0} icon={BankIcon} gradient={T.gradGreen} format={fmt} delay={130} />
            <HeroCard label="Total Returned" value={s.total_returned || 0} icon={TrendingDownIcon} gradient={T.gradAmber} format={fmt} delay={160} />
            <HeroCard label="Total Excess (Before Adjustment)" value={s.total_excess || 0} icon={TrendingUpIcon} gradient={T.gradRed} format={fmt} delay={190} />
            <HeroCard label="Closed Cases" value={s.closed_count || 0} icon={CheckIcon} gradient={T.gradTeal} delay={220} />
          </Box>
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr 1fr', sm: 'repeat(3,1fr)', md: 'repeat(4,1fr)' }, gap: 2, mb: 3 }}>
            <HeroCard label="Payable (Forensic-Adjusted)" value={s.total_payable_forensic_adjusted || 0} icon={WalletIcon} gradient={T.gradPurple} format={fmt} delay={250} />
            <HeroCard label="Amount Recovered" value={s.total_recovered_amount || 0} icon={CheckIcon} gradient={T.gradGreen} format={fmt} delay={280} />
            <HeroCard label="Reduced by Forensic Audit" value={s.total_reduced_by_forensic || 0} icon={ScaleIcon} gradient={T.gradRed} format={fmt} delay={310} />
            <HeroCard label="Installments Pending" value={s.payment_stage_pending_installments_count || 0} icon={PaymentIcon} gradient={T.gradAmber} delay={340} />
          </Box>

          {/* CHARTS ROW */}
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '2fr 1fr' }, gap: 2, mb: 3 }}>
            <Card delay={400} sx={{ p: 3 }}>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={2.5}>
                <Box display="flex" alignItems="center" gap={1}>
                  <TimelineIcon sx={{ color: T.blue, fontSize: 18 }} />
                  <Typography sx={{ fontSize: 13, fontWeight: 700, color: T.textPrimary }}>Amount &amp; Records Trend</Typography>
                </Box>
                <Box display="flex" gap={1}>
                  <ToggleChip label="Daily" active={chartMode === 'daily'} onClick={() => setChartMode('daily')} />
                  <ToggleChip label="Monthly" active={chartMode === 'monthly'} onClick={() => setChartMode('monthly')} />
                </Box>
              </Box>
              <Box display="flex" gap={2} mb={1.5} flexWrap="wrap">
                <LegendDot color={T.blue} label="Records" /><LegendDot color={T.teal} label="Deposited" />
                <LegendDot color={T.amber} label="Returned" /><LegendDot color={T.red} label="Excess" />
              </Box>
              <ResponsiveContainer width="100%" height={220}>
                <AreaChart data={chartData} margin={{ top: 5, right: 5, bottom: 5, left: 0 }}>
                  <defs>
                    <linearGradient id="caGRec" x1="0" y1="0" x2="0" y2="1"><stop offset="5%" stopColor={T.blue} stopOpacity={0.18} /><stop offset="95%" stopColor={T.blue} stopOpacity={0.01} /></linearGradient>
                    <linearGradient id="caGDep" x1="0" y1="0" x2="0" y2="1"><stop offset="5%" stopColor={T.teal} stopOpacity={0.18} /><stop offset="95%" stopColor={T.teal} stopOpacity={0.01} /></linearGradient>
                    <linearGradient id="caGRet" x1="0" y1="0" x2="0" y2="1"><stop offset="5%" stopColor={T.amber} stopOpacity={0.18} /><stop offset="95%" stopColor={T.amber} stopOpacity={0.01} /></linearGradient>
                    <linearGradient id="caGExc" x1="0" y1="0" x2="0" y2="1"><stop offset="5%" stopColor={T.red} stopOpacity={0.18} /><stop offset="95%" stopColor={T.red} stopOpacity={0.01} /></linearGradient>
                  </defs>
                  <CartesianGrid strokeDasharray="3 3" stroke={T.border} vertical={false} />
                  <XAxis dataKey="label" tick={{ fill: T.textMuted, fontSize: 10 }} axisLine={false} tickLine={false} tickFormatter={(v) => String(v)?.slice(5) || v} />
                  <YAxis yAxisId="left" tick={{ fill: T.textMuted, fontSize: 10 }} axisLine={false} tickLine={false} />
                  <YAxis yAxisId="right" tick={{ fill: T.textMuted, fontSize: 10 }} axisLine={false} tickLine={false} orientation="right" tickFormatter={(v) => fmt(v)} />
                  <ReTooltip content={<CustomTooltip />} />
                  <Area yAxisId="left" type="monotone" dataKey="Records" name="Records" stroke={T.blue} fill="url(#caGRec)" strokeWidth={2} dot={false} activeDot={{ r: 4, fill: T.blue }} />
                  <Area yAxisId="right" type="monotone" dataKey="Deposited" name="Deposited" stroke={T.teal} fill="url(#caGDep)" strokeWidth={2} dot={false} activeDot={{ r: 4, fill: T.teal }} />
                  <Area yAxisId="right" type="monotone" dataKey="Returned" name="Returned" stroke={T.amber} fill="url(#caGRet)" strokeWidth={2} dot={false} activeDot={{ r: 4, fill: T.amber }} />
                  <Area yAxisId="right" type="monotone" dataKey="Excess" name="Excess" stroke={T.red} fill="url(#caGExc)" strokeWidth={2} dot={false} activeDot={{ r: 4, fill: T.red }} />
                </AreaChart>
              </ResponsiveContainer>
            </Card>

            <Card delay={450} sx={{ p: 3 }}>
              <Box display="flex" alignItems="center" gap={1} mb={2}>
                <GavelIcon sx={{ color: T.purple, fontSize: 18 }} />
                <Typography sx={{ fontSize: 13, fontWeight: 700, color: T.textPrimary }}>Workflow Split</Typography>
              </Box>
              <ResponsiveContainer width="100%" height={150}>
                <PieChart>
                  <Pie data={workflowPie} cx="50%" cy="50%" innerRadius={42} outerRadius={65} paddingAngle={4} dataKey="value" startAngle={90} endAngle={-270}>
                    {workflowPie.map((entry, i) => <Cell key={i} fill={entry.color} stroke={`${entry.color}30`} strokeWidth={2} />)}
                  </Pie>
                  <ReTooltip contentStyle={{ background: '#fff', border: `1px solid ${T.border}`, borderRadius: 8, fontSize: 12, boxShadow: T.shadow }} />
                </PieChart>
              </ResponsiveContainer>
              <Box display="flex" gap={2} mt={0.5} flexWrap="wrap" justifyContent="center">
                {workflowPie.map((d) => (
                  <Box key={d.name} display="flex" alignItems="center" gap={0.75}>
                    <Box sx={{ width: 8, height: 8, borderRadius: '50%', background: d.color }} />
                    <Typography sx={{ fontSize: 11, color: T.textSecondary }}>{d.name} ({d.value})</Typography>
                  </Box>
                ))}
              </Box>

              <Box sx={{ mt: 2, p: 1.5, borderRadius: '10px', background: T.greenSoft, border: `1.5px solid ${T.greenMid}` }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.75}>
                  <Typography sx={{ fontSize: 11, color: T.textSecondary, fontWeight: 600 }}>Recovery Rate</Typography>
                  <Typography sx={{ fontSize: 14, color: T.green, fontWeight: 800 }}>{recoveryRate.toFixed(2)}%</Typography>
                </Box>
                <Box sx={{ height: 6, borderRadius: 3, background: `${T.greenMid}55` }}>
                  <Box sx={{ height: '100%', width: `${recoveryRate}%`, background: `linear-gradient(90deg,${T.green},#38A169)`, borderRadius: 3, transition: 'width 1.4s cubic-bezier(0.23,1,0.32,1)' }} />
                </Box>
                <Typography sx={{ fontSize: 10, color: T.textMuted, mt: 0.5 }}>
                  {fmt(s.total_recovered_amount || 0)} of {fmt(s.total_payable_forensic_adjusted || 0)} payable
                </Typography>
              </Box>
            </Card>
          </Box>

          {/* FORENSIC AUDIT — aggregate only, no per-case list */}
          <Card delay={470} sx={{ p: 3, mb: 3 }}>
            <SectionHeader icon={GavelIcon} title="Forensic-Adjusted Payable — Detail" color={T.purple} colorBg={T.purpleSoft} />
            {/* <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr 1fr', md: 'repeat(4,1fr)' }, gap: 1.5 }}>
              <StatMini label="WF2 Awaiting Amount" value={s.forensic_amount_pending_count || 0} total={(s.workflow_2_count || 1)} color={T.amber} softColor={T.amberSoft} delay={480} />
              <StatMini label="WF2 With Amount Set" value={s.forensic_cases_with_amount || 0} total={(s.workflow_2_count || 1)} color={T.green} softColor={T.greenSoft} delay={520} />
              <StatMini label="Payment Stage — Paid" value={s.payment_stage_fully_paid_count || 0} total={((s.payment_stage_fully_paid_count || 0) + (s.payment_stage_pending_installments_count || 0)) || 1} color={T.teal} softColor={T.tealSoft} delay={560} />
              <StatMini label="Payment Stage — Pending" value={s.payment_stage_pending_installments_count || 0} total={((s.payment_stage_fully_paid_count || 0) + (s.payment_stage_pending_installments_count || 0)) || 1} color={T.red} softColor={T.redSoft} delay={600} />
            </Box> */}
            <Box sx={{ mt: 2, p: 2, borderRadius: '10px', background: T.cardBgAlt, border: `1.5px solid ${T.border}` }}>
              <AmountBar label="Original Amount Sent to Forensic Auditor" value={s.total_original_amount_to_forensic || 0} maxVal={s.total_excess || 1} color={T.gray} softColor={`${T.grayMid}40`} delay={620} />
              <AmountBar label="Forensic Auditor's Determined Amount" value={s.total_forensic_determined_amount || 0} maxVal={s.total_excess || 1} color={T.purple} softColor={`${T.purpleMid}40`} delay={660} />
              <AmountBar label="Reduced by Forensic Audit" value={s.total_reduced_by_forensic || 0} maxVal={s.total_excess || 1} color={T.red} softColor={`${T.redMid}40`} delay={700} />
            </Box>
          </Card>

          {/* STAGE BREAKDOWN */}
          <Card delay={720} sx={{ p: 3, mb: 3 }}>
            <SectionHeader icon={AssessmentIcon} title="Stage-by-Stage Breakdown" color={T.blue} colorBg={T.blueSoft} />
            <ResponsiveContainer width="100%" height={280}>
              <BarChart data={stageChartData} layout="vertical" margin={{ left: 10, right: 20 }}>
                <CartesianGrid strokeDasharray="3 3" stroke={T.border} horizontal={false} />
                <XAxis type="number" tick={{ fill: T.textMuted, fontSize: 10 }} axisLine={false} tickLine={false} />
                <YAxis type="category" dataKey="stage" width={190} tick={{ fill: T.textSecondary, fontSize: 11 }} axisLine={false} tickLine={false} />
                <ReTooltip content={<CustomTooltip />} />
                <Bar dataKey="count" radius={[0, 6, 6, 0]}>
                  {stageChartData.map((_, i) => <Cell key={i} fill={STAGE_BAR_COLORS[i % STAGE_BAR_COLORS.length]} />)}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </Card>

          {/* PAYMENT TREND */}
          <Card delay={740} sx={{ p: 3, mb: 3 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2.5}>
              <Box display="flex" alignItems="center" gap={1}>
                <WalletIcon sx={{ color: T.purple, fontSize: 18 }} />
                <Typography sx={{ fontSize: 13, fontWeight: 700, color: T.textPrimary }}>Agreed Amount vs Recovered — {chartMode === 'daily' ? 'Daily' : 'Monthly'}</Typography>
              </Box>
              <Box display="flex" gap={2}><LegendDot color={T.teal} label="Agreed Amt" /><LegendDot color={T.green} label="Recovered" /></Box>
            </Box>
            <ResponsiveContainer width="100%" height={200}>
              <BarChart data={paymentChartData} margin={{ top: 5, right: 10, bottom: 5, left: 0 }} barSize={chartMode === 'daily' ? 8 : 22} barGap={3}>
                <defs>
                  <linearGradient id="caBarAgreed" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor={T.teal} stopOpacity={0.9} /><stop offset="100%" stopColor={T.tealMid} stopOpacity={0.5} /></linearGradient>
                  <linearGradient id="caBarRec" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor={T.green} stopOpacity={0.9} /><stop offset="100%" stopColor={T.greenMid} stopOpacity={0.5} /></linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" stroke={T.border} vertical={false} />
                <XAxis dataKey="label" tick={{ fill: T.textMuted, fontSize: 10 }} axisLine={false} tickLine={false} tickFormatter={(v) => String(v)?.slice(5) || v} />
                <YAxis tick={{ fill: T.textMuted, fontSize: 10 }} axisLine={false} tickLine={false} tickFormatter={(v) => fmt(v)} />
                <ReTooltip content={<CustomTooltip />} />
                <Bar dataKey="Agreed Amt" name="Agreed Amt" fill="url(#caBarAgreed)" radius={[4, 4, 0, 0]} />
                <Bar dataKey="Recovered" name="Recovered" fill="url(#caBarRec)" radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </Card>

          {/* ORDER STATUS */}
          <Card delay={760} sx={{ p: 3, mb: 3 }}>
            <SectionHeader icon={GavelIcon} title="Order Status Overview" color={T.blue} colorBg={T.blueSoft} />
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2,1fr)', md: 'repeat(4,1fr)' }, gap: 1.5 }}>
              <TriStatRow label="Freezing Order" waiting={s.freezing_delivery_waiting || 0} delivered={s.freezing_delivery_delivered || 0} returned={s.freezing_delivery_returned || 0} delay={780} />
              <TriStatRow label="Summons" waiting={s.summons_delivery_waiting || 0} delivered={s.summons_delivery_delivered || 0} returned={s.summons_delivery_returned || 0} delay={800} />
              <DualStatRow label="Bank Freezed" yes={s.bank_freezed || 0} no={s.bank_not_freezed || 0} colorYes={T.red} colorNo={T.textMuted} delay={820} />
              <DualStatRow label="Partial Unfreeze Submitted" yes={s.partial_unfreeze_submitted || 0} no={s.partial_unfreeze_not_submitted || 0} colorYes={T.teal} colorNo={T.textMuted} delay={840} />
              <DualStatRow label="Partially Unfreezed" yes={s.partial_unfreezed || 0} no={s.partial_not_unfreezed || 0} colorYes={T.green} colorNo={T.textMuted} delay={860} />
              <DualStatRow label="Defreezing Submitted" yes={s.defreezing_submitted || 0} no={s.defreezing_not_submitted || 0} colorYes={T.amber} colorNo={T.textMuted} delay={880} />
              <DualStatRow label="Bank De-freezed" yes={s.bank_defreezed || 0} no={s.bank_not_defreezed || 0} colorYes={T.green} colorNo={T.textMuted} delay={900} />
            </Box>
          </Card>

          {/* DOCS + PAYMENT */}
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2, mb: 3 }}>
            <Card delay={920} sx={{ p: 3 }}>
              <SectionHeader icon={DocsIcon} title="Document Status" color={T.teal} colorBg={T.tealSoft} />
              <Box display="flex" flexDirection="column" gap={1.5}>
                <DualStatRow label="Address Proof Submitted" yes={s.address_proof_submitted || 0} no={s.address_proof_not_submitted || 0} colorYes={T.blue} colorNo={T.red} delay={940} />
                <DualStatRow label="PAN Card Submitted" yes={s.pan_submitted || 0} no={s.pan_not_submitted || 0} colorYes={T.amber} colorNo={T.red} delay={960} />
                <DualStatRow label="Aadhar Card Submitted" yes={s.aadhar_submitted || 0} no={s.aadhar_not_submitted || 0} colorYes={T.purple} colorNo={T.red} delay={980} />
                <DualStatRow label="Affidavit Submitted" yes={s.affidavit_submitted || 0} no={s.affidavit_not_submitted || 0} colorYes={T.teal} colorNo={T.red} delay={1000} />
                <DualStatRow label="Bank Statement Submitted" yes={s.bank_statement_submitted || 0} no={s.bank_statement_not_submitted || 0} colorYes={T.green} colorNo={T.red} delay={1020} />
              </Box>
            </Card>

            <Card delay={940} sx={{ p: 3 }}>
              <SectionHeader icon={PaymentIcon} title="Payment Breakdown" color={T.amber} colorBg={T.amberSoft} />
              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 1.5, mb: 2 }}>
                <StatMini label="Agreed" value={s.agreed_to_pay || 0} total={s.total_records || 1} color={T.green} softColor={T.greenSoft} delay={960} />
                <StatMini label="Not Agreed" value={s.not_agreed_to_pay || 0} total={s.total_records || 1} color={T.red} softColor={T.redSoft} delay={1000} />
                <StatMini label="Pending" value={s.pending_payment_decision || 0} total={s.total_records || 1} color={T.amber} softColor={T.amberSoft} delay={1040} />
              </Box>
              <Box sx={{ p: 2, borderRadius: '10px', background: T.cardBgAlt, border: `1.5px solid ${T.border}` }}>
                <Typography sx={{ fontSize: 11, color: T.textMuted, textTransform: 'uppercase', letterSpacing: 1, fontWeight: 600, mb: 1.5 }}>Amount Flow</Typography>
                <AmountBar label="Total Excess" value={s.total_excess || 0} color={T.red} softColor={`${T.redMid}40`} maxVal={s.total_excess || 1} delay={1060} />
                <AmountBar label="Payable (Forensic-Adjusted)" value={s.total_payable_forensic_adjusted || 0} color={T.purple} softColor={`${T.purpleMid}40`} maxVal={s.total_excess || 1} delay={1090} />
                <AmountBar label="Recovered" value={s.total_recovered_amount || 0} color={T.green} softColor={`${T.greenMid}40`} maxVal={s.total_excess || 1} delay={1120} />
              </Box>
            </Card>
          </Box>
        </>
      )}

      <SnackBarComponent open={snackbarOpen} message={snackbarMsg} severity={snackbarSev} onClose={() => setSnackbarOpen(false)} />
    </Box>
  );
};

export default CaDashboardComponent;